var _style, _g, _g2, _polygon, _polygon2, _g3, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _path, _g4, _path2, _polygon14, _g5, _g6, _polygon15, _path3, _g7, _path4, _path5, _path6, _g8, _g9, _polygon16, _path7, _g10, _defs, _polygon17, _polygon18, _path8, _g11, _g12, _path9, _path10, _polygon19, _polygon20, _path11, _path12, _g13, _path13, _g14, _g15, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g16, _g17, _g18, _g19, _g20, _g21, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g22, _g23, _g24, _path36, _path37, _g25, _path38, _path39, _path40, _path41, _g26, _path42, _g27, _path43, _path44, _g28, _path45, _path46;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFourEncastrable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 230.6 198",
    style: {
      enableBackground: "new 0 0 230.6 198"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.4;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#A4A5A7;}\n\t.st3{fill:#64666F;}\n\t.st4{fill:#222431;}\n\t.st5{fill:#4C6A84;}\n\t.st6{fill:url(#SVGID_2_);}\n\t.st7{fill:#9B9C9E;}\n\t.st8{fill:#4E505A;}\n\t.st9{fill:url(#SVGID_3_);}\n\t.st10{fill:url(#SVGID_4_);}\n\t.st11{fill:url(#SVGID_5_);}\n\t.st12{fill:#002B50;}\n\t.st13{fill:url(#SVGID_6_);}\n\t.st14{fill:#C8C9CA;}\n\t.st15{fill:url(#SVGID_7_);}\n\t.st16{enable-background:new    ;}\n\t.st17{fill:url(#SVGID_8_);}\n\t.st18{fill:#DBDBDC;}\n\t.st19{fill:url(#SVGID_9_);}\n\t.st20{fill:url(#SVGID_10_);}\n\t.st21{fill:#7A7C83;}\n\t.st22{fill:#B6B7B8;}\n\t.st23{fill:#E4E4E5;}\n\t.st24{fill:#D2D2D3;}\n\t.st25{fill:#BFC0C1;}\n\t.st26{fill:url(#SVGID_11_);}\n\t.st27{fill:url(#SVGID_12_);}\n\t.st28{fill:url(#SVGID_13_);}\n\t.st29{fill:url(#SVGID_14_);}\n\t.st30{fill:url(#SVGID_15_);}\n\t.st31{fill:#EDEDED;}\n\t.st32{fill:none;}\n\t.st33{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st34{fill:url(#SVGID_17_);}\n\t.st35{opacity:0.7;mask:url(#SVGID_16_);fill:#D1D1D1;}\n\t.st36{fill:#383A45;}\n\t.st37{fill:url(#SVGID_18_);}\n\t.st38{fill:#F6F6F6;}\n\t.st39{opacity:0.05;fill:#C56000;}\n\t.st40{fill:#C56000;}\n\t.st41{opacity:0.051;fill:#C56000;}\n\t.st42{opacity:0.3;}\n\t.st43{opacity:0;}\n\t.st44{opacity:0.0909;}\n\t.st45{opacity:0.1818;}\n\t.st46{opacity:0.2727;}\n\t.st47{opacity:0.3636;}\n\t.st48{opacity:0.4545;}\n\t.st49{opacity:0.5455;}\n\t.st50{opacity:0.6364;}\n\t.st51{opacity:0.7273;}\n\t.st52{opacity:0.8182;}\n\t.st53{opacity:0.9091;}\n\t.st54{fill:url(#SVGID_19_);}\n\t.st55{fill:url(#SVGID_20_);}\n\t.st56{fill:url(#SVGID_21_);}\n\t.st57{fill:url(#SVGID_22_);}\n\t.st58{fill:url(#SVGID_23_);}\n\t.st59{fill:url(#SVGID_24_);}\n\t.st60{fill:url(#SVGID_25_);}\n\t.st61{fill:url(#SVGID_26_);}\n\t.st62{fill:url(#SVGID_27_);}\n\t.st63{fill:url(#SVGID_28_);}\n\t.st64{fill:url(#SVGID_29_);}\n\t.st65{fill:url(#SVGID_30_);}\n\t.st66{fill:url(#SVGID_31_);}\n\t.st67{fill:url(#SVGID_32_);}\n\t.st68{fill:url(#SVGID_33_);}\n\t.st69{fill:url(#SVGID_34_);}\n\t.st70{fill:url(#SVGID_35_);}\n\t.st71{fill:url(#SVGID_36_);}\n\t.st72{fill:url(#SVGID_37_);}\n\t.st73{fill:url(#SVGID_38_);}\n\t.st74{fill:url(#SVGID_39_);}\n\t.st75{fill:url(#SVGID_40_);}\n\t.st76{fill:url(#SVGID_41_);}\n\t.st77{fill:url(#SVGID_42_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REPERES"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.68,139.05c0.83,0.47,0.83,1.26,0,1.72l-71.76,41.43c-0.82,0.47-2.16,0.47-2.99,0l-68.02-39.27 c-0.82-0.48-0.82-1.25,0-1.73l71.76-41.42c0.82-0.48,2.17-0.48,2.99,0L186.68,139.05z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.1255,
    y1: 86.6479,
    x2: 125.0224,
    y2: 19.2763
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4431,
    style: {
      stopColor: "#E4E4E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2D2D3"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "93.9,91.14 39.44,59.7 117.25,14.79 171.7,46.23  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "187.26,136.04 109.47,180.95 109.47,113.59 187.26,68.68  "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "186.48,68.24 108.69,113.15 104.8,110.91 182.59,66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "186.48,135.6 108.69,180.51 108.69,113.15 186.48,68.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "108.69,180.51 104.8,178.27 104.8,110.9 108.69,113.15  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.6255,
    y1: 149.303,
    x2: 93.5232,
    y2: 81.9302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBDBDC"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "104.8,178.27 39.44,140.54 39.46,59.71 86.11,86.64 93.9,82.15 109.47,91.14 111.11,112.3  109.47,113.26 104.8,110.58  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "119.27,107.74 109.47,113.26 109.47,91.14 112.76,91.14  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "171.7,73.17 117.25,104.6 125.02,109.1 179.49,77.66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.3113,
    y1: 90.5828,
    x2: 151.2578,
    y2: 93.9543
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4031,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E4E5"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "191.13,70.93 113.33,115.85 109.44,113.6 187.24,68.69  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.8171,
    y1: 152.3342,
    x2: 137.645,
    y2: 101.8067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFC0C1"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "191.13,138.3 113.33,183.21 113.33,115.84 191.13,70.93  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.4398,
    y1: 148.4072,
    x2: 113.3331,
    y2: 148.4072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E4E5"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "113.33,183.21 109.44,180.97 109.44,113.6 113.33,115.84  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "113.33,169.4 109.44,167.16 109.44,113.6 113.33,115.84  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "109.47,113.59 187.26,68.69 191.13,70.93 113.33,115.85  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.8599,
    y1: 103.4915,
    x2: 169.7582,
    y2: 36.1176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9583,
    style: {
      stopColor: "#E5E5E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E4E5"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "191.15,48.47 113.35,93.38 109.47,91.14 187.26,46.23  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "191.15,68.68 113.35,113.59 113.35,93.38 191.15,48.47  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.4673,
    y1: 102.3611,
    x2: 113.3496,
    y2: 102.3611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E4E5"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "113.35,113.59 109.47,111.34 109.47,91.14 113.35,93.38  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.135,
    y1: 63.518,
    x2: 63.1947,
    y2: 63.518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#DBDBDC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M62.14,64.24c0-0.98,0-1.96,0-2.93c0,0.54,0.35,1.07,1.06,1.48l-0.01,2.93 C62.49,65.31,62.13,64.77,62.14,64.24z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "96.33,81.93 96.33,84.86 63.19,65.72 63.19,62.79  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.1355,
    y1: 83.9083,
    x2: 116.6955,
    y2: 24.0196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5969,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBDBDC"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M159.64,45.13c1.4,0.81,1.41,2.14,0.02,2.95l-58.24,33.85c-1.39,0.81-3.68,0.81-5.08,0L63.19,62.79 c-1.4-0.81-1.41-2.13-0.02-2.94l58.24-33.85c1.4-0.81,3.69-0.81,5.08,0L159.64,45.13z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.4525,
    y1: 97.7138,
    x2: 168.7133,
    y2: 30.6647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4431,
    style: {
      stopColor: "#E4E4E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2D2D3"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "109.47,91.14 93.9,82.15 171.7,37.24 187.26,46.23  "
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "45.8,67.66 47.12,68.42 47.13,75.06 45.81,74.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "47.13,75.06 47.13,75.71 45.24,74.62 45.81,74.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "45.81,74.31 45.24,74.62 45.23,67.33 45.8,67.66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "49.58,69.84 50.91,70.61 50.93,77.25 49.59,76.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "50.93,77.25 50.91,77.9 49.03,76.82 49.59,76.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "49.59,76.48 49.03,76.82 49.01,69.51 49.58,69.84  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "53.37,72.03 54.69,72.79 54.69,79.44 53.37,78.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "54.69,79.44 54.68,80.1 52.8,79 53.37,78.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "53.37,78.67 52.8,79 52.79,71.7 53.37,72.03  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "57.14,74.22 58.46,74.99 58.46,81.62 57.14,80.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "58.46,81.62 58.46,82.28 56.57,81.19 57.14,80.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "57.14,80.86 56.57,81.19 56.58,73.89 57.14,74.22  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "60.93,76.39 62.25,77.16 62.25,83.79 60.93,83.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "62.25,83.79 62.26,84.46 60.36,83.36 60.93,83.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "60.93,83.04 60.36,83.36 60.36,76.06 60.93,76.39  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "64.71,78.58 66.03,79.34 66.03,85.97 64.72,85.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "66.03,85.97 66.03,86.63 64.15,85.54 64.72,85.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "64.72,85.21 64.15,85.54 64.14,78.25 64.71,78.58  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "68.48,80.75 69.8,81.52 69.82,88.17 68.49,87.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "69.82,88.17 69.82,88.82 67.93,87.72 68.49,87.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "68.49,87.4 67.93,87.72 67.92,80.43 68.48,80.75  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "72.27,82.94 73.59,83.7 73.61,90.34 72.28,89.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "73.61,90.34 73.6,90.99 71.72,89.91 72.28,89.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "72.28,89.57 71.72,89.91 71.7,82.62 72.27,82.94  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "76.05,85.12 77.38,85.89 77.38,92.53 76.05,91.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "77.38,92.53 77.38,93.17 75.49,92.08 76.05,91.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "76.05,91.76 75.49,92.08 75.48,84.8 76.05,85.12  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "79.83,87.32 81.16,88.08 81.16,94.72 79.84,93.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "81.16,94.72 81.16,95.37 79.27,94.28 79.84,93.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "79.84,93.95 79.27,94.28 79.27,86.98 79.83,87.32  "
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "75.61,59.86 75.9,60.03 83.14,55.84 82.85,55.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "83.14,55.84 83.27,55.77 82.85,55.53 82.85,55.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "82.85,55.67 82.85,55.53 75.49,59.79 75.61,59.86  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "76.45,60.34 76.73,60.51 83.97,56.32 83.69,56.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "83.97,56.32 84.1,56.25 83.69,56.01 83.69,56.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "83.69,56.16 83.69,56.01 76.32,60.26 76.45,60.34  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "77.27,60.82 77.57,60.99 84.81,56.8 84.51,56.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "84.81,56.8 84.93,56.73 84.52,56.5 84.51,56.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "84.51,56.64 84.52,56.5 77.15,60.75 77.27,60.82  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "78.1,61.3 78.4,61.46 85.64,57.28 85.34,57.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "85.64,57.28 85.76,57.21 85.34,56.97 85.34,57.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "85.34,57.12 85.34,56.97 77.98,61.23 78.1,61.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "78.94,61.78 79.22,61.95 86.46,57.77 86.18,57.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "86.46,57.77 86.6,57.7 86.18,57.45 86.18,57.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "86.18,57.6 86.18,57.45 78.81,61.71 78.94,61.78  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "79.77,62.26 80.06,62.43 87.3,58.25 87.01,58.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "87.3,58.25 87.42,58.17 87.01,57.93 87.01,58.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "87.01,58.08 87.01,57.93 79.64,62.19 79.77,62.26  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "80.6,62.74 80.89,62.91 88.13,58.73 87.84,58.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "88.13,58.73 88.25,58.66 87.83,58.42 87.84,58.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "87.84,58.56 87.83,58.42 80.48,62.67 80.6,62.74  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "81.43,63.22 81.72,63.39 88.96,59.21 88.67,59.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "88.96,59.21 89.09,59.14 88.67,58.9 88.67,59.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "88.67,59.04 88.67,58.9 81.31,63.15 81.43,63.22  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "82.26,63.71 82.55,63.87 89.79,59.69 89.5,59.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "89.79,59.69 89.91,59.62 89.5,59.38 89.5,59.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "89.5,59.52 89.5,59.38 82.13,63.63 82.26,63.71  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "83.1,64.17 83.39,64.34 90.63,60.16 90.34,59.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "90.63,60.16 90.75,60.09 90.34,59.85 90.34,59.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "90.34,59.99 90.34,59.85 82.97,64.11 83.1,64.17  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "85.28,54.28 85.56,54.44 92.8,50.26 92.52,50.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "92.8,50.26 92.93,50.19 92.52,49.95 92.52,50.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "92.52,50.1 92.52,49.95 85.15,54.21 85.28,54.28  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "86.1,54.76 86.39,54.93 93.64,50.75 93.34,50.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "93.64,50.75 93.76,50.68 93.34,50.44 93.34,50.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "93.34,50.58 93.34,50.44 85.98,54.69 86.1,54.76  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "86.93,55.24 87.23,55.41 94.47,51.23 94.17,51.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "94.47,51.23 94.59,51.15 94.17,50.91 94.17,51.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "94.17,51.06 94.17,50.91 86.81,55.17 86.93,55.24  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "87.77,55.73 88.06,55.89 95.29,51.71 95.01,51.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "95.29,51.71 95.42,51.63 95.01,51.4 95.01,51.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "95.01,51.54 95.01,51.4 87.64,55.65 87.77,55.73  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "88.6,56.2 88.89,56.37 96.13,52.19 95.83,52.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "96.13,52.19 96.25,52.12 95.83,51.88 95.83,52.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "95.83,52.02 95.83,51.88 88.47,56.13 88.6,56.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "89.43,56.68 89.72,56.85 96.96,52.67 96.66,52.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "96.96,52.67 97.08,52.6 96.67,52.36 96.66,52.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "96.66,52.5 96.67,52.36 89.31,56.61 89.43,56.68  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "90.26,57.17 90.55,57.33 97.79,53.15 97.5,52.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "97.79,53.15 97.92,53.08 97.5,52.84 97.5,52.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "97.5,52.99 97.5,52.84 90.14,57.1 90.26,57.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "91.09,57.65 91.38,57.82 98.62,53.64 98.33,53.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "98.62,53.64 98.75,53.56 98.33,53.32 98.33,53.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "98.33,53.47 98.33,53.32 90.96,57.57 91.09,57.65  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "91.92,58.13 92.22,58.3 99.46,54.11 99.16,53.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "99.46,54.11 99.57,54.04 99.16,53.81 99.16,53.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "99.16,53.94 99.16,53.81 91.8,58.06 91.92,58.13  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "92.76,58.6 93.05,58.77 100.29,54.59 100,54.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "100.29,54.59 100.41,54.51 100,54.28 100,54.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "100,54.42 100,54.28 92.63,58.53 92.76,58.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "94.93,48.71 95.22,48.87 102.46,44.69 102.17,44.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "102.46,44.69 102.59,44.62 102.17,44.37 102.17,44.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "102.17,44.52 102.17,44.37 94.81,48.63 94.93,48.71  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "95.76,49.18 96.06,49.35 103.3,45.17 103,45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "103.3,45.17 103.42,45.1 103,44.86 103,45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "103,45 103,44.86 95.64,49.11 95.76,49.18  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "96.6,49.66 96.88,49.83 104.12,45.65 103.84,45.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "104.12,45.65 104.25,45.58 103.84,45.34 103.84,45.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "103.84,45.48 103.84,45.34 96.46,49.59 96.6,49.66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "97.43,50.15 97.72,50.32 104.96,46.13 104.66,45.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "104.96,46.13 105.08,46.06 104.66,45.82 104.66,45.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "104.66,45.96 104.66,45.82 97.3,50.08 97.43,50.15  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "98.25,50.63 98.55,50.8 105.79,46.61 105.49,46.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "105.79,46.61 105.91,46.54 105.49,46.3 105.49,46.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "105.49,46.45 105.49,46.3 98.13,50.56 98.25,50.63  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "99.09,51.11 99.38,51.28 106.61,47.09 106.33,46.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "106.61,47.09 106.75,47.02 106.33,46.78 106.33,46.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "106.33,46.93 106.33,46.78 98.97,51.03 99.09,51.11  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "99.92,51.58 100.21,51.75 107.45,47.57 107.16,47.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "107.45,47.57 107.57,47.5 107.16,47.27 107.16,47.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "107.16,47.4 107.16,47.27 99.79,51.52 99.92,51.58  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "100.75,52.07 101.04,52.24 108.28,48.06 107.99,47.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "108.28,48.06 108.4,47.99 107.99,47.75 107.99,47.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "107.99,47.89 107.99,47.75 100.63,52 100.75,52.07  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "101.58,52.55 101.87,52.72 109.11,48.54 108.82,48.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "109.11,48.54 109.24,48.47 108.82,48.22 108.82,48.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "108.82,48.37 108.82,48.22 101.46,52.48 101.58,52.55  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "102.42,53.02 102.71,53.19 109.95,49.01 109.65,48.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "109.95,49.01 110.07,48.94 109.65,48.7 109.65,48.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "109.65,48.84 109.65,48.7 102.3,52.95 102.42,53.02  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "104.59,43.13 104.88,43.29 112.12,39.11 111.83,38.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "112.12,39.11 112.25,39.04 111.83,38.8 111.83,38.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "111.83,38.94 111.83,38.8 104.47,43.05 104.59,43.13  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "105.42,43.61 105.71,43.77 112.95,39.6 112.67,39.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "112.95,39.6 113.08,39.52 112.67,39.28 112.67,39.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "112.67,39.42 112.67,39.28 105.3,43.54 105.42,43.61  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "106.26,44.09 106.55,44.26 113.78,40.07 113.49,39.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "113.78,40.07 113.91,40 113.49,39.76 113.49,39.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "113.49,39.91 113.49,39.76 106.13,44.02 106.26,44.09  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "107.08,44.57 107.38,44.74 114.62,40.56 114.32,40.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "114.62,40.56 114.74,40.48 114.32,40.24 114.32,40.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "114.32,40.39 114.32,40.24 106.96,44.5 107.08,44.57  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "107.91,45.05 108.21,45.22 115.44,41.03 115.16,40.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "115.44,41.03 115.57,40.96 115.16,40.72 115.16,40.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "115.16,40.87 115.16,40.72 107.79,44.98 107.91,45.05  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "108.75,45.53 109.04,45.7 116.28,41.52 115.99,41.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "116.28,41.52 116.4,41.44 115.99,41.2 115.99,41.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "115.99,41.35 115.99,41.2 108.62,45.46 108.75,45.53  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "109.57,46.01 109.87,46.18 117.11,42 116.82,41.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "117.11,42 117.23,41.92 116.82,41.68 116.82,41.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "116.82,41.83 116.82,41.68 109.46,45.94 109.57,46.01  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "110.41,46.49 110.7,46.66 117.94,42.48 117.65,42.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "117.94,42.48 118.06,42.41 117.65,42.17 117.65,42.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "117.65,42.31 117.65,42.17 110.29,46.42 110.41,46.49  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "111.24,46.97 111.53,47.14 118.77,42.96 118.49,42.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "118.77,42.96 118.89,42.89 118.49,42.65 118.49,42.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "118.49,42.79 118.49,42.65 111.12,46.9 111.24,46.97  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "112.08,47.45 112.37,47.62 119.6,43.43 119.32,43.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "119.6,43.43 119.73,43.36 119.32,43.12 119.32,43.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "119.32,43.26 119.32,43.12 111.95,47.37 112.08,47.45  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "114.25,37.55 114.54,37.72 121.78,33.53 121.49,33.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "121.78,33.53 121.91,33.46 121.49,33.22 121.49,33.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "121.49,33.37 121.49,33.22 114.13,37.47 114.25,37.55  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "115.09,38.03 115.38,38.2 122.61,34.02 122.33,33.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "122.61,34.02 122.74,33.94 122.33,33.7 122.33,33.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "122.33,33.85 122.33,33.7 114.95,37.96 115.09,38.03  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "115.91,38.51 116.21,38.68 123.44,34.5 123.15,34.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "123.44,34.5 123.57,34.42 123.15,34.18 123.15,34.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "123.15,34.33 123.15,34.18 115.79,38.44 115.91,38.51  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "116.75,38.99 117.04,39.16 124.27,34.98 123.99,34.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "124.27,34.98 124.4,34.9 123.99,34.66 123.99,34.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "123.99,34.81 123.99,34.66 116.62,38.92 116.75,38.99  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "117.58,39.47 117.87,39.64 125.11,35.46 124.82,35.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "125.11,35.46 125.24,35.39 124.82,35.14 124.82,35.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "124.82,35.29 124.82,35.14 117.45,39.4 117.58,39.47  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "118.41,39.95 118.7,40.12 125.94,35.94 125.64,35.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "125.94,35.94 126.06,35.87 125.65,35.63 125.64,35.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "125.64,35.77 125.65,35.63 118.28,39.88 118.41,39.95  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "119.23,40.43 119.53,40.6 126.78,36.42 126.48,36.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "126.78,36.42 126.9,36.35 126.48,36.11 126.48,36.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "126.48,36.25 126.48,36.11 119.11,40.36 119.23,40.43  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "120.07,40.91 120.36,41.08 127.6,36.91 127.31,36.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "127.6,36.91 127.72,36.83 127.31,36.59 127.31,36.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "127.31,36.73 127.31,36.59 119.94,40.84 120.07,40.91  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "120.9,41.4 121.19,41.57 128.43,37.38 128.14,37.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "128.43,37.38 128.55,37.31 128.14,37.07 128.14,37.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "128.14,37.22 128.14,37.07 120.78,41.33 120.9,41.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "121.74,41.87 122.03,42.04 129.27,37.86 128.98,37.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "129.27,37.86 129.39,37.78 128.98,37.54 128.98,37.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "128.98,37.68 128.98,37.54 121.61,41.8 121.74,41.87  "
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.9258,
    y1: 104.9118,
    x2: 104.5265,
    y2: 88.283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBDBDC"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "109.47,113.26 86.11,99.82 86.11,86.64 93.9,82.15 109.47,91.14  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.8964,
    y1: 133.0195,
    x2: 46.6485,
    y2: 134.3221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#EDEDED"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M45.6,133.19l0.76-0.43c0,0.47,0.33,1.05,0.75,1.3l-0.75,0.44C45.93,134.25,45.6,133.67,45.6,133.19z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "45.71,93.42 46.46,92.99 46.35,132.76 45.6,133.19  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.2739,
    y1: 93.1013,
    x2: 46.1204,
    y2: 92.8355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6207,
    style: {
      stopColor: "#CECECF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9524,
    style: {
      stopColor: "#C1C2C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFC0C1"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M45.93,92.95c0.25-0.15,0.5-0.3,0.75-0.43c-0.13,0.07-0.22,0.24-0.22,0.47l-0.75,0.43 C45.71,93.19,45.8,93.02,45.93,92.95z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.7225,
    y1: 163.1068,
    x2: 96.5655,
    y2: 162.835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1964,
    style: {
      stopColor: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#EDEDED"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M97.28,162.78c-0.25,0.14-0.5,0.29-0.74,0.43c-0.14,0.08-0.33,0.07-0.54-0.05l0.74-0.43 C96.96,162.85,97.15,162.86,97.28,162.78z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.995,
    y1: 144.1039,
    x2: 82.4935,
    y2: 105.1353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBDBDC"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M41.23,81.31l60.18,34.75l-0.15,51.87l-60.18-34.75L41.23,81.31z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "101.41,116.06 102.16,115.62 102.01,167.5 101.26,167.93  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "41.23,81.31 41.97,80.88 102.16,115.62 101.41,116.06  "
  })))))), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "178.87,78.02 152.25,93.38 178.87,78.02  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M191.13,97.88V70.93l-0.62,0.36l-38.26,22.08l-38.92,22.47v0.72v26.22V169c0,0.4,0.28,0.56,0.62,0.36 l38.3-22.11l38.25-22.08c0.34-0.2,0.62-0.68,0.62-1.08V97.88z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M130.41,116.71c0-0.4,0.28-0.88,0.62-1.08l42.44-24.5c0.34-0.2,0.62-0.04,0.62,0.36v40 c0,0.4-0.28,0.88-0.62,1.08l-42.44,24.5c-0.34,0.2-0.62,0.04-0.62-0.36V116.71z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 113.82,
    y: 97.42,
    width: 32.34,
    height: 70.46
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 113.82,
    y: 97.42,
    width: 32.34,
    height: 70.46,
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st33"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 4838.1138,
    y1: 113.2222,
    x2: 4815.6836,
    y2: 152.0728,
    gradientTransform: "matrix(-1 0 0 1 4956.8848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0491,
    style: {
      stopColor: "#CBCBCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1434,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2389,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3337,
    style: {
      stopColor: "#424242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4276,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5205,
    style: {
      stopColor: "#111111"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6119,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#000000"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "132.38,157.16 146.16,97.42 113.82,116.08 113.82,167.88  "
  })))), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "132.38,157.16 146.16,97.42 113.82,116.08 113.82,167.88  "
  })), /*#__PURE__*/React.createElement("g", null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M131.43,96.7c-1.27,0-2.1-1.04-2.1-2.63c0-2.24,1.59-4.97,3.54-6.09c0.58-0.33,1.13-0.5,1.65-0.5 c1.27,0,2.09,1.04,2.09,2.64c0,2.24-1.59,4.97-3.55,6.09C132.5,96.54,131.94,96.71,131.43,96.7z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M130,90.65c0.06-0.03,0.12-0.09,0.16-0.16c0.09-0.15,0.09-0.31,0-0.36c-0.04-0.02-0.09-0.02-0.16,0.01 c-0.05,0.03-0.11,0.09-0.15,0.17c-0.09,0.15-0.09,0.3,0,0.35C129.89,90.69,129.95,90.68,130,90.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M130.01,96.94c-0.06,0.03-0.11,0.09-0.15,0.16c-0.09,0.15-0.09,0.31,0,0.36c0.04,0.02,0.1,0.01,0.15-0.02 c0.06-0.03,0.12-0.09,0.16-0.16c0.09-0.15,0.09-0.31,0-0.36C130.13,96.9,130.07,96.9,130.01,96.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.93,93.54c-0.06,0.03-0.11,0.09-0.16,0.17c-0.08,0.15-0.08,0.31,0,0.36c0.05,0.02,0.1,0.01,0.16-0.02 c0.06-0.03,0.11-0.09,0.16-0.16c0.09-0.15,0.09-0.31,0-0.36C136.04,93.5,135.99,93.5,135.93,93.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.16,89.44c-0.12,0.07-0.22,0.23-0.22,0.38c0,0.13,0.09,0.19,0.21,0.12c0,0,0,0,0.01,0l0,0 c0.12-0.07,0.22-0.24,0.22-0.37C137.38,89.42,137.28,89.37,137.16,89.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M132.97,87.54c0.12-0.07,0.22-0.24,0.22-0.38c0-0.14-0.09-0.2-0.22-0.13c-0.12,0.07-0.22,0.24-0.22,0.38 C132.74,87.56,132.85,87.61,132.97,87.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M132.97,96.64c-0.13,0.07-0.23,0.24-0.23,0.38c0,0.14,0.1,0.19,0.23,0.12c0.13-0.07,0.22-0.23,0.22-0.38 C133.19,96.63,133.1,96.58,132.97,96.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.93,87.25c0.06-0.03,0.11-0.09,0.16-0.16c0.09-0.15,0.09-0.3,0-0.35c-0.05-0.02-0.1-0.02-0.16,0.02 c-0.05,0.03-0.11,0.09-0.16,0.17c-0.08,0.14-0.08,0.3,0,0.35C135.82,87.29,135.88,87.28,135.93,87.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M128.78,94.24c-0.12,0.07-0.21,0.24-0.21,0.38c0,0.14,0.09,0.2,0.21,0.13c0,0,0,0,0,0s0,0,0,0 c0.12-0.07,0.22-0.24,0.22-0.37C129,94.23,128.9,94.17,128.78,94.24z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M175.72,67.31c-0.12,0.07-0.21,0.24-0.21,0.37c0,0.15,0.09,0.2,0.21,0.13c0.12-0.07,0.22-0.24,0.22-0.38 C175.94,67.3,175.84,67.24,175.72,67.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M174.49,65.12c0.05-0.03,0.11-0.09,0.16-0.16c0.08-0.15,0.08-0.31,0-0.36c-0.05-0.03-0.1-0.02-0.16,0.02 c-0.06,0.03-0.11,0.09-0.16,0.16c-0.09,0.15-0.09,0.31,0,0.36C174.38,65.16,174.43,65.15,174.49,65.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M171.53,65.41c0.12-0.07,0.22-0.23,0.22-0.38c0-0.14-0.09-0.19-0.22-0.13c-0.13,0.07-0.22,0.24-0.22,0.38 C171.31,65.43,171.41,65.49,171.53,65.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M168.58,74.81c-0.06,0.03-0.11,0.09-0.17,0.17c-0.08,0.15-0.08,0.3,0,0.35c0.05,0.03,0.1,0.02,0.17-0.02 c0.05-0.03,0.11-0.08,0.15-0.16c0.09-0.15,0.09-0.31,0-0.36C168.68,74.77,168.63,74.78,168.58,74.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M171.54,74.52c-0.12,0.07-0.22,0.24-0.22,0.37c0,0.15,0.1,0.2,0.22,0.13c0.12-0.08,0.22-0.24,0.22-0.38 C171.76,74.51,171.66,74.44,171.54,74.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M174.5,71.41c-0.06,0.03-0.12,0.09-0.16,0.16c-0.09,0.15-0.09,0.31,0,0.36c0.04,0.02,0.1,0.02,0.16-0.02 c0.05-0.03,0.11-0.09,0.15-0.17c0.08-0.14,0.08-0.3,0-0.35C174.61,71.37,174.55,71.38,174.5,71.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M168.57,68.52c0.06-0.03,0.11-0.09,0.15-0.17c0.09-0.15,0.09-0.3,0-0.36c-0.05-0.03-0.1-0.01-0.15,0.02 c-0.06,0.03-0.11,0.09-0.16,0.16c-0.08,0.15-0.08,0.31,0,0.36C168.47,68.56,168.52,68.55,168.57,68.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M167.35,72.11c-0.12,0.07-0.22,0.24-0.22,0.38c0,0.14,0.1,0.2,0.23,0.12c0.12-0.07,0.21-0.23,0.21-0.38 C167.56,72.1,167.47,72.05,167.35,72.11z"
  }))), /*#__PURE__*/React.createElement("g", null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M157.76,72.39c0-0.46-0.33-0.66-0.73-0.43l-9.55,5.48c-0.4,0.23-0.73,0.8-0.73,1.26v10.96 c0,0.46,0.34,0.65,0.73,0.42l9.55-5.48c0.4-0.23,0.73-0.8,0.73-1.26V72.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.967,
    y1: 84.5771,
    x2: 157.7017,
    y2: 83.3045
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#E4E4E5"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M157.49,83.18c0,0.47-0.34,1.04-0.74,1.27l0.27,0.15c0.4-0.23,0.73-0.81,0.73-1.27L157.49,83.18z"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "147.21,89.93 147.48,90.09 157.02,84.61 156.76,84.46  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "157.49,83.18 157.76,83.34 157.76,72.39 157.49,72.23  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M146.85,90.02c0.03,0.05,0.07,0.08,0.11,0.12c0.13,0.08,0.32,0.07,0.52-0.05l-0.27-0.16 C147.08,90.01,146.95,90.04,146.85,90.02z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M157.49,72.23l0.27,0.16c0-0.23-0.08-0.39-0.21-0.47c-0.05-0.02-0.1-0.04-0.16-0.04 C157.44,71.96,157.49,72.08,157.49,72.23z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "150.46,80.96 150.51,81 150.45,81.11 149.73,81.52 149.68,81.48 149.74,81.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "150.48,82.07 150.53,82.11 150.47,82.97 150.4,83.08 150.35,83.04 150.41,82.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "150.56,81.02 150.61,81.06 150.54,81.91 150.48,82.02 150.43,81.98 150.49,81.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "150.38,82.03 150.44,82.07 150.37,82.18 149.65,82.59 149.6,82.55 149.67,82.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "149.55,82.6 149.61,82.64 149.54,83.5 149.49,83.6 149.43,83.57 149.49,82.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "149.63,81.55 149.69,81.59 149.62,82.45 149.56,82.55 149.5,82.52 149.57,81.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "150.31,83.1 150.36,83.14 150.3,83.25 149.57,83.66 149.52,83.62 149.58,83.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "151.77,81.24 151.83,81.27 151.76,81.38 151.04,81.79 150.99,81.75 151.06,81.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "151.69,82.3 151.75,82.35 151.69,82.45 150.97,82.86 150.91,82.83 150.97,82.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "151.86,80.17 151.91,80.21 151.84,80.31 151.13,80.72 151.07,80.69 151.13,80.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "150.94,81.8 151,81.84 150.94,82.7 150.87,82.81 150.82,82.77 150.88,81.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "151.02,80.75 151.07,80.79 151.01,81.65 150.95,81.75 150.89,81.71 150.96,80.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "151.94,80.23 152,80.26 151.93,81.12 151.87,81.23 151.82,81.19 151.88,80.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "151.87,81.28 151.93,81.31 151.86,82.18 151.8,82.28 151.74,82.24 151.8,81.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "153.54,79.2 153.6,79.24 153.53,79.34 152.81,79.75 152.75,79.72 152.82,79.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "153.55,80.31 153.6,80.34 153.54,81.21 153.48,81.31 153.43,81.28 153.49,80.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "153.38,81.34 153.43,81.38 153.37,81.48 152.65,81.9 152.6,81.86 152.67,81.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "153.63,79.26 153.68,79.29 153.62,80.16 153.56,80.26 153.5,80.22 153.57,79.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "153.47,80.27 153.51,80.31 153.45,80.41 152.73,80.83 152.67,80.79 152.74,80.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "152.63,80.84 152.68,80.88 152.62,81.73 152.56,81.84 152.5,81.8 152.56,80.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "152.71,79.78 152.76,79.82 152.7,80.68 152.63,80.79 152.58,80.75 152.64,79.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "154.1,78.99 154.15,79.02 154.09,79.89 154.03,79.99 153.98,79.95 154.03,79.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "154.02,80.04 154.08,80.07 154.02,80.94 153.95,81.04 153.9,81 153.96,80.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "154.95,79.51 155,79.54 154.94,80.41 154.87,80.51 154.82,80.48 154.89,79.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "155.02,78.45 155.08,78.49 155.02,79.36 154.95,79.46 154.9,79.42 154.96,78.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "154.85,79.47 154.9,79.51 154.84,79.61 154.12,80.03 154.07,79.99 154.14,79.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "154.77,80.54 154.83,80.58 154.77,80.68 154.04,81.09 153.99,81.06 154.05,80.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "154.93,78.4 154.98,78.43 154.92,78.54 154.2,78.96 154.15,78.92 154.21,78.82  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M152.3,80.52c0.03-0.02,0.05,0,0.05,0.04c0,0.04-0.04,0.08-0.07,0.1c-0.04,0.02-0.05,0-0.05-0.03 C152.23,80.59,152.26,80.54,152.3,80.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M152.23,81.4c0.03-0.02,0.05,0,0.05,0.04c0,0.04-0.04,0.09-0.06,0.11c-0.04,0.02-0.05,0-0.05-0.04 C152.16,81.46,152.19,81.41,152.23,81.4z"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M169.99,74.57c-1.27,0-2.09-1.03-2.09-2.63c0-2.24,1.59-4.98,3.54-6.1c0.57-0.33,1.12-0.49,1.64-0.49 c1.27,0.01,2.09,1.04,2.09,2.63c0,2.24-1.59,4.98-3.54,6.1C171.06,74.41,170.5,74.57,169.99,74.57z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M133.1,100.08c-0.65-0.01-1.59-1.01-2.37-2.21c-0.78-1.21-1.39-2.61-1.39-3.43 c0-1.15,0.41-2.43,1.08-3.56c0.66-1.13,1.57-2.12,2.57-2.7c0.59-0.33,1.16-0.5,1.69-0.5c1.29,0,2.13,1.07,2.12,2.69 c-0.01,1.15,0,2.89-0.18,4.56c-0.17,1.68-0.52,3.29-1.23,4.21C134.68,100.09,133.63,100.09,133.1,100.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M130.44,90.89c0.66-1.13,1.57-2.12,2.57-2.69c0.72-0.41,1.38-0.47,1.86-0.27 c1.17,0.04,1.93,1.03,1.92,2.55c-0.01,1.08-0.02,2.7-0.2,4.26c-0.17,1.56-0.51,3.06-1.17,3.94c-0.72,0.95-1.74,1.04-2.32,1.09 c-0.77,0.1-1.73-0.92-2.47-2.2c-0.68-1.17-1.25-2.48-1.24-3.28C129.41,93.18,129.81,91.96,130.44,90.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M130.45,90.89c0.66-1.13,1.57-2.11,2.56-2.68c0.84-0.48,1.6-0.45,2.03-0.04c1.06,0.07,1.74,1,1.72,2.4 c-0.02,1.02-0.04,2.51-0.21,3.96c-0.17,1.44-0.5,2.83-1.11,3.66c-0.71,0.96-1.72,1.14-2.34,1.24c-0.89,0.2-1.88-0.82-2.58-2.18 c-0.58-1.12-1.11-2.36-1.08-3.14C129.47,93.07,129.85,91.92,130.45,90.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M130.46,90.9c0.66-1.13,1.56-2.11,2.56-2.68c0.97-0.55,1.81-0.42,2.2,0.2c0.94,0.1,1.54,0.97,1.51,2.26 c-0.02,0.95-0.06,2.32-0.23,3.65c-0.17,1.33-0.49,2.6-1.05,3.38c-0.71,0.97-1.7,1.25-2.36,1.4c-1.01,0.3-2.02-0.72-2.69-2.17 c-0.49-1.07-0.98-2.23-0.93-2.99C129.54,92.96,129.89,91.87,130.46,90.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M130.47,90.91c0.66-1.12,1.56-2.1,2.55-2.67c1.09-0.62,2.03-0.39,2.37,0.43 c0.82,0.13,1.35,0.94,1.31,2.11c-0.03,0.88-0.08,2.14-0.25,3.35c-0.17,1.21-0.47,2.37-0.99,3.1c-0.71,0.99-1.68,1.35-2.38,1.55 c-1.13,0.4-2.17-0.61-2.8-2.16c-0.41-1.02-0.84-2.1-0.77-2.84C129.6,92.84,129.94,91.82,130.47,90.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M130.49,90.92c0.65-1.12,1.56-2.1,2.55-2.67c1.22-0.69,2.25-0.37,2.54,0.66c0.7,0.16,1.15,0.91,1.11,1.96 c-0.03,0.81-0.1,1.95-0.26,3.05c-0.17,1.09-0.45,2.15-0.93,2.83c-0.7,1-1.66,1.45-2.4,1.71c-1.25,0.51-2.33-0.5-2.91-2.14 c-0.34-0.96-0.7-1.97-0.62-2.69C129.65,92.73,129.98,91.78,130.49,90.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M130.5,90.92c0.65-1.12,1.55-2.09,2.54-2.66c1.34-0.76,2.47-0.34,2.71,0.89c0.59,0.2,0.95,0.88,0.9,1.82 c-0.04,0.75-0.12,1.76-0.28,2.75c-0.16,0.98-0.44,1.92-0.87,2.55c-0.7,1.02-1.64,1.56-2.42,1.86 c-1.37,0.61-2.49-0.39-3.01-2.13c-0.27-0.89-0.56-1.84-0.47-2.54C129.71,92.62,130.03,91.73,130.5,90.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M130.51,90.93c0.65-1.12,1.55-2.09,2.54-2.66c1.47-0.84,2.69-0.31,2.88,1.12 c0.47,0.23,0.76,0.85,0.7,1.67c-0.05,0.68-0.13,1.57-0.3,2.44c-0.16,0.86-0.42,1.69-0.81,2.27c-0.69,1.03-1.62,1.66-2.44,2.01 c-1.49,0.71-2.67-0.27-3.12-2.11c-0.2-0.83-0.43-1.71-0.31-2.39C129.77,92.51,130.07,91.68,130.51,90.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M130.52,90.94c0.65-1.11,1.55-2.08,2.53-2.65c1.6-0.91,2.9-0.29,3.05,1.35c0.35,0.26,0.56,0.82,0.5,1.53 c-0.05,0.61-0.15,1.39-0.32,2.14c-0.16,0.75-0.4,1.46-0.75,1.99c-0.68,1.05-1.6,1.76-2.46,2.17c-1.61,0.81-2.86-0.15-3.23-2.1 c-0.15-0.77-0.29-1.58-0.16-2.24C129.83,92.4,130.12,91.64,130.52,90.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M130.54,90.95c0.65-1.11,1.54-2.08,2.53-2.64c1.72-0.98,3.12-0.26,3.22,1.59 c0.23,0.29,0.36,0.78,0.29,1.38c-0.06,0.55-0.17,1.2-0.33,1.84c-0.16,0.63-0.39,1.24-0.69,1.71c-0.67,1.07-1.58,1.87-2.48,2.32 c-1.73,0.92-3.06-0.03-3.34-2.08c-0.09-0.7-0.16-1.45-0.01-2.1C129.88,92.29,130.16,91.59,130.54,90.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M130.55,90.95c0.65-1.11,1.54-2.07,2.52-2.64c1.85-1.05,3.01-0.2,3.39,1.82 c0.06,0.34,0.16,0.75,0.09,1.24c-0.07,0.48-0.19,1.01-0.35,1.53c-0.16,0.51-0.37,1.01-0.63,1.44c-0.66,1.09-1.56,1.97-2.5,2.48 c-1.85,1.02-3.3,0.09-3.45-2.07c-0.04-0.64-0.02-1.32,0.15-1.95C129.94,92.18,130.2,91.54,130.55,90.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.08,88.33c1.97-1.12,3.56-0.21,3.56,2.05c0,1.13-0.4,2.38-1.05,3.48s-1.54,2.07-2.52,2.63 c-1.97,1.12-3.56,0.2-3.55-2.06c0-1.13,0.41-2.37,1.05-3.48C131.21,89.86,132.1,88.89,133.08,88.33z"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M171.57,77.75c-0.65,0-1.59-1-2.36-2.21c-0.78-1.21-1.39-2.61-1.39-3.43c0.01-1.15,0.42-2.43,1.08-3.57 c0.66-1.13,1.57-2.12,2.58-2.69c0.59-0.34,1.15-0.51,1.68-0.5c1.29,0.01,2.12,1.06,2.12,2.7c0,1.15,0,2.89-0.18,4.56 c-0.18,1.68-0.53,3.29-1.23,4.21C173.15,77.76,172.1,77.76,171.57,77.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M168.91,68.56c0.66-1.13,1.57-2.12,2.57-2.69c0.71-0.41,1.37-0.48,1.85-0.27 c1.18,0.04,1.93,1.03,1.92,2.55c-0.01,1.08-0.02,2.7-0.2,4.26c-0.17,1.56-0.52,3.06-1.17,3.93c-0.72,0.95-1.75,1.04-2.32,1.08 c-0.77,0.1-1.73-0.91-2.47-2.19c-0.68-1.17-1.26-2.49-1.24-3.28C167.88,70.85,168.28,69.64,168.91,68.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M168.92,68.56c0.66-1.13,1.57-2.11,2.57-2.68c0.84-0.48,1.59-0.45,2.02-0.03c1.06,0.07,1.74,1,1.72,2.41 c-0.01,1.02-0.04,2.51-0.21,3.95c-0.17,1.44-0.5,2.83-1.11,3.65c-0.71,0.96-1.73,1.14-2.34,1.24c-0.89,0.2-1.88-0.82-2.58-2.18 c-0.58-1.12-1.12-2.36-1.08-3.13C167.94,70.74,168.32,69.59,168.92,68.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M168.93,68.57c0.66-1.13,1.56-2.11,2.57-2.68c0.96-0.55,1.81-0.42,2.19,0.2c0.94,0.1,1.54,0.97,1.51,2.26 c-0.02,0.95-0.06,2.32-0.23,3.65c-0.17,1.33-0.49,2.6-1.05,3.38c-0.71,0.97-1.7,1.24-2.36,1.39c-1.01,0.31-2.02-0.71-2.69-2.16 c-0.49-1.07-0.98-2.23-0.93-2.98C168,70.63,168.36,69.54,168.93,68.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M168.94,68.58c0.66-1.12,1.56-2.1,2.56-2.67c1.09-0.62,2.03-0.39,2.36,0.43 c0.82,0.13,1.34,0.94,1.31,2.11c-0.03,0.88-0.08,2.13-0.25,3.35c-0.17,1.21-0.47,2.37-0.99,3.1c-0.71,0.99-1.68,1.35-2.38,1.55 c-1.13,0.41-2.17-0.61-2.8-2.15c-0.41-1.02-0.84-2.1-0.78-2.84C168.06,70.52,168.41,69.5,168.94,68.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M168.96,68.59c0.65-1.12,1.56-2.1,2.56-2.67c1.21-0.69,2.25-0.37,2.53,0.66 c0.71,0.16,1.15,0.91,1.11,1.97c-0.03,0.81-0.1,1.95-0.26,3.05c-0.17,1.09-0.46,2.14-0.93,2.82c-0.7,1-1.66,1.45-2.4,1.7 c-1.25,0.51-2.33-0.5-2.91-2.13c-0.34-0.96-0.7-1.97-0.62-2.69C168.12,70.41,168.45,69.45,168.96,68.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M168.97,68.59c0.65-1.12,1.55-2.09,2.55-2.66c1.34-0.76,2.46-0.34,2.7,0.9c0.59,0.2,0.95,0.88,0.9,1.82 c-0.04,0.75-0.11,1.76-0.28,2.74c-0.16,0.98-0.44,1.92-0.87,2.54c-0.7,1.02-1.64,1.55-2.42,1.86 c-1.37,0.61-2.49-0.38-3.02-2.12c-0.27-0.89-0.56-1.84-0.47-2.54C168.18,70.3,168.5,69.4,168.97,68.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M168.98,68.6c0.65-1.12,1.55-2.09,2.55-2.66c1.47-0.84,2.68-0.31,2.87,1.13c0.47,0.23,0.76,0.85,0.7,1.68 c-0.05,0.68-0.13,1.57-0.3,2.44c-0.16,0.86-0.42,1.69-0.81,2.27c-0.69,1.03-1.62,1.66-2.44,2.01 c-1.49,0.71-2.67-0.26-3.12-2.11c-0.21-0.83-0.43-1.71-0.32-2.39C168.24,70.19,168.54,69.36,168.98,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M168.99,68.61c0.65-1.11,1.55-2.09,2.54-2.65c1.59-0.91,2.9-0.28,3.04,1.36 c0.35,0.26,0.56,0.81,0.49,1.53c-0.05,0.61-0.15,1.38-0.32,2.14c-0.16,0.74-0.4,1.46-0.75,1.99c-0.68,1.05-1.6,1.76-2.46,2.17 c-1.61,0.82-2.86-0.14-3.23-2.09c-0.15-0.77-0.29-1.58-0.16-2.24C168.3,70.07,168.58,69.31,168.99,68.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M169.01,68.62c0.65-1.11,1.55-2.08,2.54-2.65c1.72-0.98,3.12-0.25,3.21,1.59 c0.23,0.29,0.36,0.78,0.29,1.38c-0.06,0.54-0.17,1.2-0.33,1.83c-0.16,0.63-0.39,1.24-0.69,1.71c-0.67,1.07-1.58,1.86-2.48,2.32 c-1.73,0.92-3.07-0.02-3.34-2.08c-0.09-0.7-0.16-1.45-0.01-2.1C168.35,69.96,168.63,69.26,169.01,68.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M169.02,68.62c0.65-1.11,1.54-2.08,2.53-2.64c1.84-1.05,3-0.19,3.38,1.83c0.06,0.34,0.16,0.75,0.09,1.24 c-0.07,0.48-0.19,1.01-0.35,1.53c-0.16,0.51-0.37,1.01-0.62,1.43c-0.66,1.08-1.56,1.97-2.5,2.48c-1.85,1.02-3.3,0.1-3.45-2.06 c-0.04-0.64-0.02-1.32,0.15-1.95C168.41,69.85,168.67,69.22,169.02,68.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.56,66c1.97-1.12,3.56-0.2,3.55,2.06c0,1.13-0.4,2.37-1.05,3.48c-0.65,1.1-1.54,2.07-2.52,2.63 c-1.97,1.12-3.56,0.21-3.56-2.05c0-1.13,0.4-2.38,1.05-3.48C169.68,67.52,170.57,66.56,171.56,66z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.6892,
    y1: 100.1756,
    x2: 136.5383,
    y2: 91.7767,
    gradientTransform: "matrix(1 2.600000e-03 -2.600000e-03 1 -1.0096 -4.2962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0647,
    style: {
      stopColor: "#BFC0C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1802,
    style: {
      stopColor: "#D8D8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#D5D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6688,
    style: {
      stopColor: "#DDDDDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7464,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7738,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9135,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9363,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8C9CA"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M135.42,87.91c-0.63-0.36-1.49-0.31-2.45,0.23c-1.9,1.09-3.45,3.75-3.45,5.93c0,1.09,0.38,1.85,1,2.21 l2.19,1.28c-0.62-0.36-1-1.13-1-2.21c0-2.17,1.54-4.84,3.44-5.92c0.96-0.55,1.83-0.6,2.45-0.23L135.42,87.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.1289,
    y1: 100.2768,
    x2: 134.7041,
    y2: 94.3448,
    gradientTransform: "matrix(1 2.600000e-03 -2.600000e-03 1 -1.0096 -4.2962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADAEB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0516,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2041,
    style: {
      stopColor: "#CACBCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6673,
    style: {
      stopColor: "#DFDFE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#EBEBED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDFDFF"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M135.15,89.42c1.91-1.09,3.45-0.21,3.45,1.97c0,2.18-1.54,4.83-3.45,5.92c-1.9,1.09-3.44,0.21-3.44-1.98 C131.71,93.17,133.25,90.51,135.15,89.42z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.1931,
    y1: 77.9502,
    x2: 175.0443,
    y2: 69.5477,
    gradientTransform: "matrix(1 2.600000e-03 -2.600000e-03 1 -1.0096 -4.2962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0647,
    style: {
      stopColor: "#BFC0C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1802,
    style: {
      stopColor: "#D8D8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#D5D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6688,
    style: {
      stopColor: "#DDDDDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7464,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7738,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9135,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9363,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8C9CA"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M173.98,65.78c-0.62-0.36-1.49-0.32-2.44,0.23c-1.9,1.09-3.44,3.75-3.44,5.93c0,1.08,0.37,1.84,0.99,2.21 l2.18,1.28c-0.62-0.36-1-1.12-1-2.21c0-2.19,1.55-4.84,3.45-5.93c0.95-0.55,1.82-0.59,2.44-0.23L173.98,65.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.631,
    y1: 78.0509,
    x2: 173.2039,
    y2: 72.1148,
    gradientTransform: "matrix(1 2.600000e-03 -2.600000e-03 1 -1.0096 -4.2962)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADAEB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0516,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2041,
    style: {
      stopColor: "#CACBCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6673,
    style: {
      stopColor: "#DFDFE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#EBEBED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDFDFF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M173.71,67.29c1.9-1.09,3.44-0.21,3.44,1.98c0,2.18-1.54,4.84-3.44,5.93c-1.9,1.09-3.45,0.21-3.45-1.97 C170.27,71.03,171.81,68.38,173.71,67.29z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M143.71,86.8c0.12,0,0.24-0.04,0.37-0.11c0.42-0.24,0.74-0.81,0.74-1.29c0-0.37-0.19-0.6-0.49-0.6 c-0.12,0-0.25,0.03-0.37,0.1c-0.41,0.24-0.75,0.81-0.75,1.29C143.22,86.56,143.42,86.8,143.71,86.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M144.34,88.75c-0.12,0-0.24,0.03-0.37,0.11c-0.41,0.24-0.74,0.81-0.74,1.29c0,0.36,0.2,0.6,0.5,0.6 c0.12,0,0.24-0.04,0.36-0.11c0.42-0.24,0.74-0.8,0.74-1.29C144.84,88.99,144.64,88.75,144.34,88.75z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M160.21,73.32c0.12,0,0.24-0.04,0.36-0.1c0.42-0.24,0.75-0.82,0.75-1.29c0-0.37-0.2-0.6-0.5-0.6 c-0.12,0-0.24,0.04-0.37,0.11c-0.41,0.24-0.75,0.82-0.75,1.29C159.71,73.08,159.91,73.32,160.21,73.32z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M160.22,77.28c0.11,0,0.23-0.04,0.37-0.12c0.41-0.23,0.74-0.81,0.74-1.29c0-0.37-0.19-0.6-0.49-0.6 c-0.12,0-0.24,0.03-0.37,0.11c-0.42,0.24-0.75,0.81-0.75,1.29C159.72,77.03,159.92,77.28,160.22,77.28z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M160.84,79.22c-0.12,0-0.24,0.04-0.37,0.12c-0.42,0.24-0.74,0.8-0.74,1.29c0,0.35,0.2,0.6,0.5,0.6 c0.12,0,0.24-0.04,0.37-0.12c0.42-0.24,0.74-0.8,0.74-1.29C161.34,79.46,161.14,79.22,160.84,79.22z"
  })), /*#__PURE__*/React.createElement("g", null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M143.7,82.85c0.11,0,0.24-0.03,0.36-0.1c0.42-0.25,0.75-0.82,0.75-1.29c0-0.36-0.2-0.61-0.5-0.61 c-0.12,0-0.24,0.04-0.37,0.11c-0.41,0.24-0.74,0.8-0.74,1.29C143.21,82.61,143.41,82.85,143.7,82.85z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M143.98,83.39c-0.13,0-0.32-0.21-0.48-0.45c-0.16-0.25-0.28-0.53-0.28-0.7c0-0.23,0.09-0.49,0.22-0.72 s0.32-0.43,0.53-0.55c0.12-0.07,0.23-0.1,0.34-0.1c0.26,0,0.43,0.22,0.43,0.55c0,0.23,0,0.59-0.04,0.93 c-0.04,0.34-0.11,0.67-0.25,0.86C144.3,83.39,144.09,83.39,143.98,83.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M143.44,81.52c0.13-0.23,0.32-0.43,0.52-0.55c0.14-0.08,0.28-0.1,0.37-0.06 c0.24,0.01,0.39,0.21,0.39,0.51c0,0.22,0,0.55-0.04,0.86c-0.04,0.32-0.11,0.62-0.24,0.8c-0.15,0.19-0.36,0.21-0.47,0.22 c-0.16,0.02-0.35-0.19-0.5-0.45c-0.14-0.24-0.26-0.51-0.25-0.67C143.23,81.98,143.31,81.74,143.44,81.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M143.44,81.52c0.13-0.23,0.32-0.43,0.52-0.54c0.17-0.1,0.32-0.09,0.41-0.01 c0.22,0.01,0.36,0.2,0.35,0.48c0,0.21-0.01,0.51-0.04,0.8c-0.04,0.29-0.1,0.57-0.23,0.74c-0.15,0.2-0.35,0.23-0.47,0.25 c-0.18,0.04-0.38-0.17-0.53-0.44c-0.12-0.23-0.23-0.48-0.22-0.63C143.24,81.96,143.32,81.73,143.44,81.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M143.45,81.52c0.13-0.23,0.32-0.43,0.52-0.54c0.19-0.11,0.37-0.08,0.44,0.04 c0.19,0.02,0.32,0.19,0.31,0.45c0,0.19-0.01,0.47-0.05,0.74c-0.04,0.27-0.1,0.53-0.22,0.69c-0.14,0.2-0.35,0.25-0.48,0.29 c-0.21,0.06-0.41-0.14-0.55-0.44c-0.1-0.22-0.2-0.45-0.19-0.6C143.26,81.94,143.33,81.72,143.45,81.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M143.45,81.52c0.13-0.23,0.32-0.43,0.52-0.54c0.22-0.13,0.41-0.08,0.48,0.09 c0.17,0.03,0.28,0.19,0.27,0.42c0,0.18-0.02,0.43-0.05,0.68c-0.03,0.25-0.1,0.48-0.2,0.63c-0.14,0.2-0.35,0.28-0.48,0.32 c-0.23,0.09-0.44-0.12-0.57-0.44c-0.08-0.21-0.17-0.42-0.16-0.57C143.27,81.92,143.34,81.71,143.45,81.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M143.45,81.52c0.13-0.23,0.32-0.43,0.52-0.54c0.24-0.14,0.45-0.07,0.51,0.13 c0.14,0.03,0.24,0.18,0.23,0.39c-0.01,0.17-0.02,0.4-0.05,0.62c-0.03,0.22-0.09,0.44-0.19,0.58c-0.14,0.2-0.34,0.3-0.49,0.35 c-0.25,0.11-0.47-0.1-0.59-0.43c-0.07-0.19-0.14-0.4-0.13-0.54C143.28,81.9,143.35,81.7,143.45,81.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M143.46,81.52c0.13-0.23,0.32-0.42,0.52-0.54c0.27-0.15,0.5-0.07,0.55,0.18 c0.12,0.04,0.2,0.17,0.19,0.36c-0.01,0.15-0.02,0.36-0.06,0.56c-0.03,0.2-0.09,0.39-0.18,0.52 c-0.14,0.21-0.34,0.32-0.49,0.38c-0.28,0.13-0.5-0.08-0.61-0.43c-0.05-0.18-0.12-0.37-0.1-0.51 C143.29,81.87,143.36,81.69,143.46,81.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M143.46,81.53c0.13-0.23,0.32-0.42,0.52-0.54c0.29-0.17,0.54-0.06,0.58,0.23 c0.1,0.04,0.16,0.17,0.14,0.33c-0.01,0.14-0.03,0.32-0.06,0.5c-0.03,0.18-0.09,0.35-0.17,0.46 c-0.14,0.21-0.33,0.34-0.49,0.41c-0.3,0.15-0.54-0.05-0.63-0.43c-0.04-0.17-0.09-0.34-0.07-0.48 C143.3,81.85,143.37,81.68,143.46,81.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M143.46,81.53c0.13-0.23,0.31-0.42,0.52-0.54c0.32-0.18,0.59-0.05,0.62,0.27 c0.07,0.05,0.11,0.16,0.1,0.3c-0.01,0.13-0.03,0.28-0.06,0.44c-0.03,0.15-0.08,0.3-0.15,0.41c-0.14,0.21-0.33,0.36-0.5,0.44 c-0.33,0.17-0.58-0.03-0.66-0.42c-0.03-0.15-0.06-0.32-0.04-0.45C143.32,81.83,143.38,81.67,143.46,81.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M143.46,81.53c0.13-0.23,0.31-0.42,0.52-0.54c0.35-0.2,0.63-0.05,0.65,0.32 c0.05,0.06,0.07,0.15,0.06,0.27c-0.01,0.11-0.03,0.25-0.07,0.38c-0.03,0.13-0.08,0.25-0.14,0.35 c-0.14,0.22-0.32,0.38-0.5,0.47c-0.35,0.19-0.62,0-0.68-0.42c-0.02-0.14-0.03-0.29-0.01-0.42 C143.33,81.81,143.39,81.66,143.46,81.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M143.47,81.53c0.13-0.22,0.31-0.42,0.51-0.54c0.37-0.21,0.61-0.03,0.69,0.37 c0.01,0.07,0.03,0.15,0.02,0.24c-0.01,0.1-0.04,0.21-0.07,0.32c-0.03,0.11-0.08,0.21-0.13,0.3c-0.13,0.22-0.32,0.4-0.51,0.5 c-0.38,0.21-0.67,0.03-0.7-0.42c-0.01-0.13-0.01-0.26,0.03-0.39C143.34,81.79,143.39,81.65,143.47,81.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.98,81c0.4-0.22,0.72-0.04,0.72,0.42c0,0.23-0.08,0.48-0.21,0.71c-0.13,0.22-0.31,0.42-0.51,0.53 c-0.4,0.24-0.72,0.05-0.72-0.41c0-0.23,0.08-0.48,0.21-0.71S143.78,81.11,143.98,81z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M144.01,87.36c-0.13,0-0.32-0.2-0.48-0.45c-0.16-0.24-0.28-0.53-0.28-0.7c0-0.23,0.08-0.49,0.22-0.72 c0.13-0.23,0.32-0.43,0.53-0.55c0.12-0.07,0.23-0.1,0.34-0.1c0.26,0,0.43,0.22,0.43,0.55c0,0.23,0,0.58-0.03,0.92 s-0.11,0.66-0.25,0.85C144.33,87.36,144.12,87.36,144.01,87.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M143.99,84.94c0.13-0.07,0.25-0.1,0.36-0.1c0.25,0.01,0.4,0.21,0.41,0.53c0,0.09,0,0.19,0,0.3 c0,0.18-0.01,0.38-0.03,0.58c-0.04,0.32-0.11,0.63-0.24,0.81c-0.15,0.2-0.36,0.21-0.47,0.22c-0.15,0.02-0.35-0.18-0.5-0.45 c-0.14-0.25-0.25-0.53-0.24-0.7c0.01-0.22,0.09-0.47,0.22-0.68C143.62,85.25,143.8,85.06,143.99,84.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M143.99,84.95c0.14-0.08,0.26-0.1,0.37-0.09c0.23,0.02,0.38,0.21,0.38,0.51c0,0.08,0,0.18,0,0.29 c0,0.17-0.01,0.36-0.03,0.55c-0.04,0.3-0.11,0.59-0.23,0.77c-0.14,0.2-0.35,0.23-0.48,0.26c-0.18,0.04-0.38-0.16-0.52-0.44 c-0.12-0.25-0.21-0.52-0.19-0.7c0.02-0.21,0.09-0.44,0.22-0.65C143.64,85.23,143.81,85.05,143.99,84.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M144,84.95c0.14-0.08,0.27-0.1,0.39-0.09c0.21,0.03,0.35,0.2,0.36,0.48c0,0.08,0.01,0.17,0,0.27 c0,0.16-0.01,0.34-0.03,0.52c-0.04,0.28-0.11,0.56-0.23,0.73c-0.14,0.2-0.35,0.26-0.48,0.29c-0.2,0.06-0.42-0.14-0.55-0.44 c-0.1-0.24-0.17-0.51-0.15-0.7c0.03-0.2,0.1-0.42,0.22-0.61C143.66,85.22,143.82,85.05,144,84.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M144,84.95c0.15-0.08,0.29-0.1,0.4-0.08c0.2,0.03,0.33,0.19,0.34,0.46c0,0.08,0.01,0.17,0.01,0.26 c0,0.15-0.01,0.32-0.03,0.49c-0.04,0.27-0.1,0.52-0.22,0.69c-0.14,0.2-0.34,0.28-0.48,0.32c-0.23,0.08-0.45-0.12-0.57-0.44 c-0.09-0.24-0.14-0.51-0.1-0.7c0.04-0.19,0.1-0.39,0.22-0.57C143.68,85.2,143.83,85.05,144,84.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M144,84.96c0.16-0.09,0.3-0.1,0.42-0.08c0.18,0.04,0.31,0.19,0.32,0.43c0,0.07,0.01,0.16,0.01,0.25 c0,0.14-0.01,0.3-0.04,0.46c-0.04,0.25-0.1,0.49-0.22,0.65c-0.14,0.21-0.34,0.3-0.49,0.35c-0.25,0.1-0.49-0.1-0.59-0.44 c-0.07-0.24-0.1-0.5-0.06-0.7c0.04-0.18,0.11-0.37,0.22-0.53C143.7,85.19,143.84,85.05,144,84.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M144,84.96c0.16-0.09,0.31-0.1,0.44-0.07c0.17,0.04,0.28,0.18,0.3,0.41c0.01,0.07,0.01,0.15,0.01,0.24 c0,0.14-0.01,0.29-0.04,0.43c-0.04,0.23-0.1,0.46-0.21,0.61c-0.14,0.21-0.33,0.32-0.49,0.38c-0.28,0.12-0.52-0.07-0.61-0.43 c-0.06-0.24-0.07-0.5-0.01-0.7c0.05-0.16,0.12-0.34,0.22-0.5C143.71,85.18,143.85,85.04,144,84.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M144,84.96c0.17-0.1,0.33-0.11,0.45-0.07c0.15,0.05,0.26,0.18,0.28,0.39c0.01,0.07,0.01,0.14,0.01,0.23 c0,0.13-0.01,0.27-0.04,0.4c-0.04,0.21-0.1,0.42-0.2,0.57c-0.14,0.21-0.33,0.34-0.5,0.41c-0.3,0.14-0.56-0.05-0.63-0.43 c-0.05-0.23-0.04-0.49,0.03-0.7c0.05-0.15,0.12-0.32,0.22-0.46C143.73,85.16,143.86,85.04,144,84.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M144,84.96c0.18-0.1,0.34-0.11,0.47-0.06c0.14,0.05,0.23,0.17,0.26,0.36c0.01,0.06,0.01,0.14,0.01,0.21 c0,0.12-0.01,0.25-0.04,0.37c-0.04,0.19-0.1,0.39-0.2,0.53c-0.14,0.21-0.33,0.36-0.5,0.44c-0.32,0.16-0.6-0.03-0.66-0.43 c-0.03-0.23,0-0.49,0.08-0.7c0.06-0.14,0.13-0.29,0.23-0.42C143.75,85.15,143.87,85.04,144,84.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M144,84.97c0.19-0.1,0.35-0.11,0.48-0.06c0.12,0.05,0.21,0.17,0.24,0.34c0.01,0.06,0.02,0.13,0.01,0.2 c0,0.11-0.01,0.23-0.04,0.34c-0.04,0.18-0.1,0.35-0.19,0.5c-0.14,0.22-0.32,0.38-0.51,0.47c-0.35,0.18-0.64,0-0.68-0.42 c-0.02-0.23,0.03-0.48,0.12-0.7c0.06-0.13,0.13-0.27,0.23-0.38C143.77,85.14,143.88,85.04,144,84.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M144,84.97c0.19-0.11,0.37-0.12,0.5-0.05c0.11,0.05,0.19,0.16,0.22,0.31c0.01,0.06,0.02,0.12,0.02,0.19 c0,0.1-0.01,0.21-0.04,0.31c-0.04,0.16-0.1,0.32-0.18,0.46c-0.13,0.22-0.32,0.4-0.51,0.5c-0.37,0.21-0.68,0.02-0.7-0.42 c-0.01-0.23,0.06-0.48,0.17-0.7c0.06-0.12,0.14-0.24,0.23-0.35C143.79,85.12,143.89,85.03,144,84.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,84.97c0.2-0.11,0.38-0.12,0.52-0.05c0.13,0.08,0.21,0.24,0.21,0.47c0,0.23-0.08,0.48-0.22,0.7 c-0.13,0.22-0.31,0.42-0.52,0.54c-0.4,0.23-0.72,0.04-0.72-0.42c0-0.23,0.08-0.48,0.22-0.7S143.81,85.09,144,84.97z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M144.04,91.33c-0.13,0-0.32-0.2-0.48-0.45c-0.16-0.24-0.28-0.53-0.28-0.69c0-0.23,0.08-0.49,0.22-0.72 s0.32-0.43,0.52-0.55c0.12-0.07,0.23-0.1,0.35-0.1c0.26,0,0.43,0.22,0.43,0.55c0,0.23,0,0.59-0.04,0.93 c-0.04,0.34-0.11,0.67-0.25,0.85C144.36,91.33,144.15,91.33,144.04,91.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M144.02,88.92c0.13-0.07,0.25-0.1,0.36-0.1c0.24,0.01,0.4,0.21,0.41,0.52c0,0.09,0,0.19,0,0.3 c0,0.18-0.01,0.38-0.03,0.58c-0.04,0.32-0.11,0.63-0.24,0.81c-0.14,0.19-0.35,0.21-0.47,0.22c-0.16,0.02-0.35-0.18-0.5-0.44 c-0.14-0.24-0.25-0.52-0.24-0.69c0.01-0.22,0.09-0.47,0.22-0.69C143.65,89.22,143.83,89.04,144.02,88.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M144.02,88.93c0.13-0.08,0.26-0.1,0.38-0.09c0.23,0.02,0.38,0.2,0.38,0.5c0,0.08,0,0.18,0,0.29 c0,0.17-0.01,0.36-0.03,0.55c-0.04,0.3-0.11,0.6-0.24,0.77c-0.14,0.19-0.34,0.23-0.47,0.25c-0.18,0.04-0.38-0.16-0.52-0.44 c-0.12-0.24-0.21-0.52-0.19-0.7c0.02-0.21,0.09-0.44,0.22-0.65C143.67,89.21,143.84,89.03,144.02,88.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M144.02,88.93c0.14-0.08,0.27-0.1,0.39-0.09c0.21,0.03,0.35,0.2,0.36,0.48c0,0.08,0,0.18,0,0.28 c0,0.16-0.01,0.34-0.03,0.52c-0.04,0.29-0.11,0.56-0.23,0.73c-0.14,0.2-0.34,0.25-0.47,0.28c-0.21,0.06-0.42-0.14-0.54-0.44 c-0.1-0.24-0.17-0.51-0.15-0.7c0.03-0.2,0.1-0.42,0.22-0.61C143.69,89.2,143.85,89.03,144.02,88.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M144.02,88.93c0.15-0.09,0.29-0.1,0.41-0.08c0.2,0.03,0.33,0.19,0.34,0.45c0,0.08,0.01,0.17,0.01,0.27 c0,0.15-0.01,0.32-0.03,0.49c-0.04,0.27-0.11,0.53-0.22,0.69c-0.14,0.2-0.34,0.27-0.48,0.31c-0.23,0.08-0.45-0.12-0.56-0.44 c-0.09-0.24-0.14-0.51-0.1-0.7c0.04-0.19,0.11-0.39,0.22-0.57C143.71,89.18,143.86,89.03,144.02,88.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M144.02,88.94c0.16-0.09,0.3-0.11,0.42-0.08c0.18,0.04,0.3,0.19,0.32,0.43c0,0.07,0.01,0.16,0.01,0.26 c0,0.14-0.01,0.3-0.03,0.46c-0.04,0.25-0.1,0.49-0.22,0.65c-0.14,0.2-0.33,0.29-0.48,0.35c-0.25,0.1-0.48-0.1-0.59-0.43 c-0.07-0.24-0.1-0.5-0.06-0.7c0.04-0.18,0.11-0.37,0.22-0.53C143.73,89.17,143.87,89.03,144.02,88.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M144.02,88.94c0.16-0.1,0.31-0.11,0.44-0.08c0.17,0.04,0.28,0.18,0.3,0.41 c0.01,0.07,0.01,0.15,0.01,0.24c0,0.14-0.01,0.28-0.04,0.43c-0.04,0.23-0.1,0.46-0.21,0.62c-0.14,0.21-0.33,0.31-0.49,0.38 c-0.28,0.12-0.52-0.08-0.61-0.43c-0.06-0.24-0.07-0.5-0.01-0.7c0.05-0.17,0.12-0.34,0.22-0.5 C143.74,89.16,143.88,89.02,144.02,88.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M144.03,88.94c0.17-0.1,0.32-0.11,0.45-0.07c0.15,0.05,0.25,0.18,0.27,0.38 c0.01,0.07,0.01,0.15,0.01,0.23c0,0.13-0.01,0.27-0.04,0.4c-0.04,0.21-0.1,0.42-0.2,0.58c-0.14,0.21-0.32,0.34-0.49,0.41 c-0.3,0.14-0.56-0.05-0.63-0.43c-0.05-0.24-0.04-0.5,0.03-0.7c0.05-0.15,0.12-0.32,0.22-0.46 C143.76,89.14,143.89,89.02,144.03,88.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M144.03,88.95c0.18-0.1,0.34-0.11,0.47-0.07c0.13,0.05,0.23,0.17,0.25,0.36 c0.01,0.06,0.01,0.14,0.01,0.22c0,0.12-0.01,0.25-0.04,0.37c-0.04,0.2-0.1,0.39-0.19,0.54c-0.13,0.21-0.32,0.36-0.5,0.44 c-0.33,0.16-0.59-0.03-0.65-0.42c-0.03-0.23-0.01-0.49,0.07-0.7c0.06-0.14,0.13-0.29,0.23-0.42 C143.78,89.13,143.9,89.02,144.03,88.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M144.03,88.95c0.19-0.11,0.35-0.12,0.48-0.06c0.12,0.05,0.21,0.16,0.23,0.33 c0.01,0.06,0.01,0.13,0.01,0.21c0,0.11-0.01,0.23-0.04,0.34c-0.04,0.18-0.1,0.35-0.19,0.5c-0.13,0.22-0.32,0.38-0.5,0.47 c-0.35,0.18-0.63-0.01-0.67-0.42c-0.02-0.23,0.02-0.49,0.12-0.71c0.06-0.13,0.13-0.27,0.23-0.38 C143.8,89.11,143.91,89.02,144.03,88.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M144.03,88.95c0.19-0.11,0.37-0.12,0.5-0.06c0.11,0.05,0.18,0.16,0.21,0.31 c0.01,0.06,0.02,0.12,0.02,0.19c0,0.1-0.01,0.21-0.04,0.31c-0.04,0.16-0.1,0.32-0.18,0.46c-0.13,0.22-0.31,0.4-0.5,0.5 c-0.38,0.2-0.67,0.02-0.7-0.42c-0.01-0.23,0.05-0.49,0.16-0.71c0.06-0.12,0.14-0.24,0.23-0.35 C143.82,89.1,143.92,89.01,144.03,88.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.03,88.96c0.2-0.12,0.38-0.13,0.51-0.06c0.13,0.07,0.21,0.24,0.21,0.47c0,0.23-0.08,0.48-0.21,0.7 c-0.13,0.22-0.31,0.42-0.51,0.54c-0.4,0.22-0.72,0.04-0.72-0.42c0-0.23,0.08-0.48,0.21-0.71 C143.65,89.26,143.83,89.07,144.03,88.96z"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M160.5,73.88c-0.13,0-0.33-0.2-0.48-0.45c-0.16-0.24-0.28-0.53-0.28-0.7c0-0.23,0.08-0.49,0.22-0.72 s0.32-0.43,0.53-0.55c0.12-0.06,0.24-0.1,0.34-0.1c0.27,0,0.43,0.22,0.43,0.55c0,0.23,0,0.59-0.04,0.92 c-0.04,0.34-0.11,0.66-0.25,0.85C160.82,73.88,160.6,73.88,160.5,73.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M159.96,72.01c0.13-0.23,0.32-0.43,0.53-0.55c0.14-0.08,0.28-0.09,0.38-0.05 c0.24,0.01,0.4,0.21,0.39,0.52c0,0.22-0.01,0.55-0.04,0.86c-0.04,0.32-0.11,0.62-0.24,0.79c-0.15,0.19-0.36,0.21-0.47,0.22 c-0.16,0.02-0.35-0.18-0.51-0.44c-0.14-0.24-0.25-0.5-0.25-0.67C159.75,72.48,159.83,72.23,159.96,72.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M159.96,72.02c0.13-0.23,0.32-0.43,0.52-0.55c0.17-0.09,0.33-0.09,0.41,0c0.22,0.01,0.36,0.2,0.35,0.49 c0,0.21-0.01,0.51-0.04,0.8c-0.04,0.29-0.1,0.57-0.23,0.74c-0.15,0.2-0.36,0.23-0.48,0.25c-0.18,0.04-0.38-0.16-0.53-0.44 c-0.12-0.23-0.23-0.48-0.22-0.64C159.76,72.46,159.84,72.22,159.96,72.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M159.96,72.02c0.13-0.23,0.32-0.43,0.52-0.55c0.2-0.11,0.37-0.08,0.44,0.04 c0.19,0.02,0.32,0.2,0.31,0.46c0,0.19-0.01,0.47-0.05,0.74c-0.03,0.27-0.1,0.53-0.21,0.68c-0.15,0.2-0.35,0.25-0.48,0.28 c-0.2,0.06-0.41-0.14-0.55-0.44c-0.1-0.22-0.2-0.45-0.19-0.6C159.77,72.44,159.85,72.22,159.96,72.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M159.97,72.02c0.13-0.23,0.32-0.43,0.52-0.54c0.22-0.12,0.41-0.08,0.48,0.09 c0.17,0.02,0.28,0.19,0.27,0.43c-0.01,0.18-0.02,0.43-0.05,0.68c-0.03,0.25-0.1,0.48-0.2,0.63c-0.14,0.2-0.35,0.27-0.48,0.32 c-0.23,0.08-0.44-0.12-0.57-0.44c-0.08-0.2-0.17-0.42-0.16-0.57C159.79,72.41,159.86,72.21,159.97,72.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M159.97,72.02c0.13-0.23,0.32-0.43,0.52-0.54c0.25-0.14,0.46-0.07,0.51,0.14 c0.15,0.03,0.24,0.18,0.23,0.4c-0.01,0.17-0.02,0.4-0.05,0.62c-0.03,0.22-0.09,0.43-0.19,0.57c-0.14,0.2-0.34,0.3-0.49,0.35 c-0.25,0.1-0.47-0.1-0.59-0.43c-0.07-0.19-0.14-0.39-0.13-0.54C159.8,72.39,159.87,72.2,159.97,72.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M159.97,72.02c0.13-0.23,0.32-0.43,0.52-0.54c0.27-0.15,0.5-0.07,0.55,0.18 c0.12,0.04,0.2,0.17,0.19,0.36c-0.01,0.15-0.02,0.36-0.06,0.56c-0.03,0.2-0.09,0.39-0.18,0.52 c-0.14,0.21-0.34,0.32-0.49,0.38c-0.27,0.13-0.5-0.08-0.61-0.43c-0.05-0.18-0.12-0.37-0.1-0.51 C159.81,72.37,159.88,72.19,159.97,72.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M159.98,72.02c0.13-0.23,0.32-0.42,0.52-0.54c0.3-0.17,0.55-0.06,0.58,0.23 c0.1,0.04,0.16,0.17,0.14,0.33c-0.01,0.14-0.03,0.32-0.06,0.5c-0.03,0.17-0.09,0.34-0.17,0.46c-0.14,0.21-0.33,0.34-0.5,0.41 c-0.3,0.15-0.54-0.05-0.63-0.43c-0.04-0.17-0.09-0.34-0.07-0.48C159.82,72.35,159.89,72.18,159.98,72.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M159.98,72.03c0.13-0.23,0.31-0.42,0.52-0.54c0.32-0.18,0.59-0.05,0.62,0.28 c0.07,0.05,0.11,0.16,0.1,0.3c-0.01,0.13-0.03,0.28-0.06,0.44c-0.03,0.15-0.08,0.3-0.15,0.4c-0.14,0.21-0.33,0.36-0.5,0.44 c-0.32,0.17-0.58-0.03-0.65-0.43c-0.03-0.15-0.06-0.31-0.03-0.45C159.84,72.33,159.89,72.17,159.98,72.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M159.98,72.03c0.13-0.23,0.31-0.42,0.51-0.54c0.35-0.2,0.63-0.05,0.65,0.33 c0.05,0.06,0.07,0.15,0.06,0.27c-0.01,0.11-0.03,0.24-0.07,0.38c-0.03,0.13-0.08,0.25-0.14,0.35 c-0.14,0.22-0.32,0.38-0.5,0.47c-0.35,0.19-0.62,0-0.68-0.42c-0.02-0.14-0.03-0.29,0-0.41 C159.85,72.31,159.9,72.16,159.98,72.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M159.99,72.03c0.13-0.22,0.31-0.42,0.51-0.54c0.37-0.21,0.68-0.04,0.68,0.37 c0.02,0.06,0.03,0.15,0.02,0.24c-0.01,0.1-0.04,0.21-0.07,0.31c-0.03,0.1-0.08,0.21-0.13,0.29c-0.13,0.22-0.32,0.4-0.51,0.5 c-0.37,0.21-0.67,0.02-0.7-0.42c-0.01-0.13-0.01-0.26,0.03-0.38C159.86,72.28,159.91,72.15,159.99,72.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5,71.5c0.4-0.23,0.72-0.04,0.72,0.42c0,0.23-0.08,0.48-0.21,0.7c-0.13,0.22-0.31,0.42-0.51,0.54 c-0.39,0.23-0.72,0.04-0.72-0.42c0-0.23,0.08-0.48,0.22-0.7C160.12,71.81,160.3,71.61,160.5,71.5z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M160.53,77.85c-0.13,0-0.32-0.2-0.48-0.45c-0.16-0.24-0.28-0.53-0.28-0.69c0-0.23,0.08-0.49,0.22-0.72 s0.32-0.43,0.52-0.55c0.12-0.07,0.23-0.1,0.34-0.1c0.26,0,0.43,0.22,0.43,0.55c0,0.23,0,0.58-0.04,0.92 c-0.04,0.34-0.11,0.67-0.25,0.85C160.85,77.86,160.64,77.85,160.53,77.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M159.99,75.99c0.13-0.23,0.32-0.43,0.52-0.55c0.15-0.08,0.28-0.1,0.38-0.05 c0.24,0.01,0.39,0.22,0.39,0.53c0,0.22-0.01,0.55-0.05,0.87c-0.04,0.32-0.12,0.63-0.26,0.81c-0.14,0.18-0.34,0.18-0.44,0.19 c-0.14,0.01-0.33-0.17-0.48-0.4c-0.16-0.23-0.28-0.5-0.28-0.67C159.77,76.48,159.85,76.22,159.99,75.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M159.99,75.99c0.13-0.23,0.32-0.43,0.52-0.54c0.17-0.1,0.32-0.09,0.41-0.01 c0.21,0.02,0.35,0.22,0.34,0.51c-0.01,0.21-0.02,0.52-0.06,0.82c-0.04,0.3-0.12,0.59-0.26,0.76 c-0.13,0.16-0.32,0.18-0.42,0.18c-0.14,0.02-0.33-0.14-0.49-0.36c-0.15-0.21-0.27-0.47-0.27-0.65 C159.77,76.48,159.86,76.22,159.99,75.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M159.99,76c0.13-0.23,0.32-0.43,0.52-0.54c0.2-0.11,0.37-0.09,0.45,0.04c0.19,0.03,0.31,0.22,0.3,0.49 c-0.01,0.2-0.02,0.5-0.07,0.77c-0.05,0.29-0.13,0.56-0.27,0.72c-0.12,0.15-0.3,0.17-0.39,0.18 c-0.15,0.03-0.34-0.11-0.49-0.31c-0.15-0.2-0.26-0.45-0.26-0.63C159.78,76.48,159.86,76.22,159.99,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M160,76c0.13-0.23,0.32-0.43,0.52-0.54c0.22-0.13,0.41-0.08,0.48,0.09c0.17,0.04,0.27,0.22,0.26,0.47 c-0.01,0.19-0.03,0.47-0.08,0.73c-0.05,0.27-0.14,0.52-0.27,0.68c-0.12,0.14-0.28,0.16-0.37,0.18 c-0.16,0.04-0.34-0.09-0.49-0.27s-0.26-0.42-0.26-0.61C159.78,76.48,159.86,76.23,160,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M160,76c0.13-0.23,0.32-0.43,0.52-0.54c0.25-0.14,0.45-0.08,0.51,0.13c0.14,0.05,0.23,0.22,0.21,0.45 c-0.01,0.19-0.04,0.44-0.09,0.68c-0.06,0.25-0.15,0.49-0.27,0.64c-0.11,0.13-0.26,0.15-0.35,0.17 c-0.16,0.05-0.35-0.06-0.5-0.22c-0.15-0.17-0.25-0.4-0.25-0.59C159.78,76.48,159.86,76.23,160,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M160,76c0.13-0.23,0.32-0.42,0.52-0.54c0.27-0.16,0.5-0.07,0.55,0.18c0.12,0.06,0.19,0.22,0.17,0.43 c-0.02,0.18-0.05,0.41-0.11,0.63c-0.06,0.23-0.15,0.45-0.28,0.59c-0.1,0.12-0.24,0.15-0.32,0.17 c-0.17,0.06-0.36-0.03-0.5-0.18c-0.14-0.15-0.24-0.37-0.24-0.57C159.78,76.48,159.87,76.23,160,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M160,76c0.13-0.23,0.32-0.42,0.52-0.54c0.3-0.17,0.54-0.07,0.58,0.23c0.09,0.07,0.15,0.22,0.13,0.41 c-0.02,0.17-0.06,0.38-0.12,0.58c-0.06,0.21-0.16,0.41-0.28,0.55c-0.1,0.11-0.22,0.14-0.3,0.17c-0.18,0.07-0.36,0-0.5-0.13 c-0.14-0.14-0.24-0.34-0.24-0.55C159.79,76.48,159.87,76.23,160,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M160.01,76c0.13-0.23,0.32-0.42,0.52-0.54c0.32-0.19,0.59-0.06,0.62,0.27 c0.07,0.08,0.11,0.22,0.08,0.39c-0.02,0.16-0.07,0.35-0.13,0.53c-0.07,0.2-0.17,0.38-0.29,0.51c-0.09,0.1-0.2,0.13-0.28,0.17 c-0.18,0.08-0.37,0.03-0.5-0.09s-0.23-0.32-0.23-0.52C159.79,76.49,159.87,76.23,160.01,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M160.01,76.01c0.13-0.23,0.32-0.42,0.52-0.53c0.35-0.21,0.63-0.06,0.65,0.32 c0.05,0.09,0.07,0.21,0.04,0.36c-0.03,0.15-0.08,0.32-0.14,0.48c-0.07,0.18-0.17,0.34-0.29,0.46 c-0.08,0.08-0.18,0.13-0.25,0.16c-0.19,0.09-0.37,0.06-0.51-0.04c-0.14-0.11-0.23-0.29-0.23-0.5 C159.79,76.49,159.88,76.23,160.01,76.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M160.01,76.01c0.13-0.22,0.31-0.42,0.51-0.53c0.37-0.22,0.63-0.05,0.69,0.37 c0.01,0.1,0.02,0.21-0.01,0.34c-0.03,0.14-0.08,0.29-0.15,0.43c-0.08,0.16-0.18,0.31-0.3,0.42 c-0.07,0.07-0.16,0.12-0.23,0.16c-0.19,0.1-0.38,0.09-0.51,0s-0.22-0.26-0.22-0.48C159.8,76.49,159.88,76.23,160.01,76.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.53,75.48c0.39-0.24,0.72-0.05,0.72,0.42c0,0.23-0.08,0.48-0.21,0.7c-0.13,0.22-0.31,0.42-0.51,0.54 c-0.2,0.11-0.38,0.12-0.51,0.05c-0.13-0.08-0.21-0.24-0.21-0.46c0-0.23,0.08-0.48,0.21-0.71 C160.14,75.78,160.33,75.59,160.53,75.48z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M160.56,81.83c-0.13,0-0.32-0.2-0.48-0.45c-0.16-0.24-0.28-0.53-0.28-0.69c0-0.23,0.08-0.49,0.22-0.72 c0.13-0.23,0.32-0.43,0.52-0.55c0.12-0.06,0.23-0.1,0.34-0.1c0.26,0,0.43,0.22,0.43,0.54c0,0.23,0,0.59-0.04,0.93 c-0.04,0.34-0.11,0.67-0.25,0.86C160.88,81.83,160.66,81.83,160.56,81.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M160.02,79.97c0.13-0.23,0.32-0.43,0.52-0.55c0.12-0.07,0.25-0.1,0.35-0.1 c0.25,0.01,0.4,0.21,0.41,0.52c0,0.09,0,0.19,0,0.3c0,0.18-0.01,0.38-0.03,0.58c-0.04,0.32-0.1,0.64-0.24,0.82 c-0.14,0.19-0.36,0.21-0.47,0.22c-0.14,0.01-0.33-0.17-0.48-0.4c-0.15-0.23-0.28-0.5-0.28-0.67 C159.8,80.46,159.88,80.2,160.02,79.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M160.02,79.97c0.13-0.23,0.32-0.43,0.52-0.54c0.13-0.07,0.26-0.1,0.37-0.09 c0.23,0.02,0.38,0.2,0.38,0.49c0,0.08,0,0.18,0,0.29c0,0.17-0.01,0.36-0.03,0.55c-0.04,0.3-0.1,0.6-0.23,0.78 c-0.14,0.19-0.35,0.23-0.48,0.25c-0.14,0.02-0.33-0.14-0.48-0.36c-0.15-0.21-0.27-0.48-0.27-0.65 C159.8,80.46,159.89,80.2,160.02,79.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M160.02,79.97c0.13-0.23,0.32-0.43,0.52-0.54c0.14-0.08,0.27-0.1,0.39-0.09 c0.21,0.03,0.35,0.2,0.36,0.47c0,0.08,0.01,0.17,0,0.28c0,0.16-0.01,0.34-0.03,0.52c-0.04,0.29-0.1,0.57-0.23,0.74 c-0.14,0.2-0.35,0.25-0.48,0.28c-0.15,0.03-0.34-0.11-0.49-0.31c-0.15-0.2-0.26-0.45-0.26-0.63 C159.81,80.46,159.89,80.2,160.02,79.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M160.03,79.97c0.13-0.23,0.32-0.43,0.52-0.54c0.15-0.08,0.29-0.1,0.4-0.08 c0.2,0.03,0.33,0.19,0.34,0.45c0,0.08,0.01,0.17,0.01,0.27c0,0.15-0.01,0.33-0.03,0.49c-0.04,0.27-0.1,0.53-0.22,0.7 c-0.14,0.2-0.34,0.27-0.48,0.31c-0.16,0.04-0.34-0.08-0.49-0.27c-0.15-0.18-0.26-0.42-0.26-0.61 C159.81,80.46,159.89,80.2,160.03,79.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M160.03,79.98c0.13-0.23,0.32-0.43,0.52-0.54c0.16-0.09,0.3-0.1,0.42-0.08 c0.18,0.04,0.3,0.19,0.32,0.42c0,0.07,0.01,0.16,0.01,0.25c0,0.15-0.01,0.31-0.04,0.46c-0.04,0.25-0.1,0.5-0.21,0.66 c-0.14,0.2-0.34,0.29-0.49,0.34c-0.16,0.05-0.35-0.06-0.49-0.22c-0.14-0.17-0.25-0.4-0.25-0.59 C159.81,80.46,159.9,80.2,160.03,79.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M160.03,79.98c0.13-0.23,0.31-0.42,0.52-0.54c0.16-0.09,0.31-0.1,0.43-0.07 c0.17,0.04,0.28,0.18,0.3,0.4c0.01,0.07,0.01,0.15,0.01,0.24c0,0.14-0.01,0.29-0.04,0.44c-0.04,0.23-0.1,0.46-0.21,0.62 c-0.14,0.21-0.33,0.31-0.49,0.37c-0.17,0.06-0.35-0.03-0.49-0.18c-0.14-0.15-0.24-0.37-0.24-0.57 C159.82,80.46,159.9,80.2,160.03,79.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M160.03,79.98c0.13-0.23,0.31-0.42,0.51-0.54c0.17-0.1,0.32-0.11,0.45-0.07 c0.15,0.05,0.25,0.17,0.28,0.38c0.01,0.07,0.01,0.14,0.01,0.23c0,0.13-0.01,0.27-0.04,0.41c-0.04,0.21-0.1,0.43-0.2,0.58 c-0.14,0.21-0.33,0.33-0.5,0.41c-0.17,0.07-0.36,0-0.5-0.13c-0.14-0.14-0.24-0.34-0.24-0.55 C159.82,80.46,159.9,80.2,160.03,79.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M160.04,79.98c0.13-0.23,0.31-0.42,0.51-0.53c0.18-0.1,0.34-0.11,0.46-0.06 c0.14,0.05,0.23,0.17,0.25,0.35c0.01,0.06,0.01,0.14,0.01,0.22c0,0.12-0.01,0.25-0.04,0.38c-0.04,0.2-0.1,0.39-0.19,0.54 c-0.14,0.21-0.32,0.36-0.5,0.44c-0.18,0.08-0.36,0.03-0.5-0.09c-0.14-0.12-0.23-0.32-0.23-0.53 C159.82,80.46,159.91,80.2,160.04,79.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M160.04,79.98c0.13-0.23,0.31-0.42,0.51-0.53c0.19-0.11,0.35-0.11,0.48-0.06 c0.12,0.05,0.21,0.16,0.23,0.33c0.01,0.06,0.02,0.13,0.01,0.2c0,0.11-0.01,0.23-0.04,0.35c-0.04,0.18-0.1,0.36-0.19,0.5 c-0.13,0.22-0.32,0.38-0.5,0.47c-0.19,0.09-0.37,0.06-0.5-0.04c-0.14-0.11-0.22-0.29-0.22-0.5 C159.83,80.46,159.91,80.2,160.04,79.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M160.04,79.98c0.13-0.22,0.31-0.42,0.51-0.53c0.19-0.11,0.37-0.12,0.5-0.06 c0.11,0.05,0.18,0.16,0.21,0.31c0.01,0.06,0.02,0.12,0.02,0.19c0,0.1-0.01,0.21-0.04,0.32c-0.04,0.16-0.1,0.32-0.18,0.46 c-0.13,0.22-0.32,0.4-0.51,0.5c-0.19,0.1-0.37,0.09-0.51,0c-0.13-0.09-0.22-0.26-0.22-0.48 C159.83,80.46,159.91,80.2,160.04,79.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.55,79.45c0.2-0.11,0.38-0.13,0.51-0.05c0.13,0.07,0.21,0.23,0.21,0.46c0,0.23-0.08,0.48-0.21,0.71 c-0.13,0.22-0.31,0.42-0.51,0.53c-0.2,0.11-0.38,0.12-0.51,0.05s-0.21-0.23-0.21-0.46c0-0.23,0.08-0.49,0.21-0.71 S160.35,79.56,160.55,79.45z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.9117,
    y1: 86.7187,
    x2: 144.2284,
    y2: 85.5352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADAEB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0516,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2041,
    style: {
      stopColor: "#CACBCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6673,
    style: {
      stopColor: "#DFDFE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#EBEBED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDFDFF"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M144.57,85.34c0.38-0.22,0.69-0.05,0.69,0.39c0,0.44-0.31,0.97-0.69,1.19 c-0.37,0.22-0.69,0.05-0.69-0.39C143.88,86.08,144.19,85.56,144.57,85.34z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.5728,
    y1: 86.6692,
    x2: 144.5428,
    y2: 84.9891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0647,
    style: {
      stopColor: "#BFC0C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1802,
    style: {
      stopColor: "#D8D8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#D5D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6688,
    style: {
      stopColor: "#DDDDDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7464,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7738,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9135,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9363,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8C9CA"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M143.54,86.65l0.54,0.32c-0.12-0.07-0.2-0.22-0.2-0.44c0-0.44,0.31-0.97,0.69-1.19 c0.19-0.11,0.37-0.13,0.49-0.05l-0.54-0.32c-0.13-0.07-0.3-0.07-0.49,0.05c-0.37,0.22-0.68,0.74-0.68,1.18 C143.34,86.42,143.41,86.58,143.54,86.65z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.9268,
    y1: 90.6678,
    x2: 144.2441,
    y2: 89.4853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADAEB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0516,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2041,
    style: {
      stopColor: "#CACBCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6673,
    style: {
      stopColor: "#DFDFE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#EBEBED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDFDFF"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M144.58,89.29c0.38-0.22,0.69-0.05,0.69,0.39c0,0.44-0.3,0.96-0.69,1.19 c-0.38,0.22-0.69,0.04-0.69-0.39C143.9,90.04,144.2,89.51,144.58,89.29z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.5832,
    y1: 90.6154,
    x2: 144.5519,
    y2: 88.9377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0647,
    style: {
      stopColor: "#BFC0C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1802,
    style: {
      stopColor: "#D8D8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#D5D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6688,
    style: {
      stopColor: "#DDDDDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7464,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7738,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9135,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9363,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8C9CA"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M144.03,88.97c-0.38,0.22-0.69,0.75-0.69,1.19c0,0.22,0.09,0.37,0.2,0.44l0.55,0.31 c-0.13-0.07-0.2-0.22-0.2-0.44c0-0.43,0.3-0.97,0.69-1.19c0.18-0.11,0.36-0.12,0.48-0.05l-0.54-0.31 C144.4,88.85,144.23,88.86,144.03,88.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.4066,
    y1: 73.2426,
    x2: 160.7216,
    y2: 72.0562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADAEB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0516,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2041,
    style: {
      stopColor: "#CACBCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6673,
    style: {
      stopColor: "#DFDFE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#EBEBED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDFDFF"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M161.06,71.86c0.38-0.22,0.69-0.05,0.69,0.39c0,0.43-0.31,0.97-0.69,1.19 c-0.38,0.22-0.69,0.05-0.7-0.39C160.37,72.61,160.69,72.08,161.06,71.86z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.0661,
    y1: 73.1915,
    x2: 161.0354,
    y2: 71.5126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0647,
    style: {
      stopColor: "#BFC0C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1802,
    style: {
      stopColor: "#D8D8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#D5D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6688,
    style: {
      stopColor: "#DDDDDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7464,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7738,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9135,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9363,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8C9CA"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M160.03,73.17l0.54,0.32c-0.12-0.07-0.2-0.22-0.2-0.44c0-0.44,0.31-0.97,0.69-1.19 c0.2-0.11,0.36-0.12,0.49-0.05l-0.55-0.32c-0.13-0.07-0.3-0.06-0.49,0.05c-0.38,0.22-0.69,0.75-0.69,1.19 C159.83,72.95,159.91,73.1,160.03,73.17z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.418,
    y1: 77.192,
    x2: 160.7337,
    y2: 76.0067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADAEB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0516,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2041,
    style: {
      stopColor: "#CACBCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6673,
    style: {
      stopColor: "#DFDFE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#EBEBED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDFDFF"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M161.07,75.81c0.38-0.22,0.69-0.05,0.69,0.39c0,0.43-0.3,0.97-0.69,1.19 c-0.38,0.22-0.69,0.04-0.69-0.39C160.39,76.56,160.69,76.03,161.07,75.81z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.0758,
    y1: 77.139,
    x2: 161.0461,
    y2: 75.4585
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0647,
    style: {
      stopColor: "#BFC0C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1802,
    style: {
      stopColor: "#D8D8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#D5D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6688,
    style: {
      stopColor: "#DDDDDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7464,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7738,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9135,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9363,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8C9CA"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M160.04,77.12l0.55,0.32c-0.12-0.07-0.2-0.22-0.2-0.44c0-0.43,0.3-0.97,0.68-1.19 c0.19-0.11,0.37-0.12,0.49-0.05l-0.54-0.32c-0.13-0.07-0.3-0.07-0.49,0.05c-0.37,0.22-0.69,0.75-0.69,1.19 C159.84,76.9,159.92,77.05,160.04,77.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.088,
    y1: 81.0903,
    x2: 161.0588,
    y2: 79.4088
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0647,
    style: {
      stopColor: "#BFC0C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1802,
    style: {
      stopColor: "#D8D8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#D5D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6688,
    style: {
      stopColor: "#DDDDDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7464,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7738,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9135,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9363,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8C9CA"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M161.03,79.39c-0.12-0.07-0.3-0.06-0.49,0.05c-0.38,0.22-0.69,0.75-0.69,1.19c0,0.22,0.07,0.37,0.2,0.44 l0.55,0.32c-0.12-0.07-0.19-0.22-0.2-0.44c0-0.43,0.3-0.97,0.69-1.18c0.19-0.11,0.36-0.12,0.49-0.05L161.03,79.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.4338,
    y1: 81.1442,
    x2: 160.7473,
    y2: 79.9553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADAEB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0516,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2041,
    style: {
      stopColor: "#CACBCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6673,
    style: {
      stopColor: "#DFDFE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#EBEBED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDFDFF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M161.09,79.76c0.37-0.22,0.69-0.04,0.69,0.4c0,0.44-0.31,0.97-0.68,1.18c-0.38,0.22-0.69,0.04-0.69-0.4 C160.4,80.51,160.71,79.98,161.09,79.76z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.9056,
    y1: 82.7698,
    x2: 144.2196,
    y2: 81.5816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADAEB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0516,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2041,
    style: {
      stopColor: "#CACBCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3547,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6673,
    style: {
      stopColor: "#DFDFE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8403,
    style: {
      stopColor: "#EBEBED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDFDFF"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M144.56,81.38c0.37-0.22,0.69-0.04,0.69,0.39c0,0.43-0.31,0.97-0.69,1.19 c-0.38,0.22-0.69,0.04-0.69-0.4S144.19,81.6,144.56,81.38z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.5628,
    y1: 82.7205,
    x2: 144.533,
    y2: 81.0401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0647,
    style: {
      stopColor: "#BFC0C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1802,
    style: {
      stopColor: "#D8D8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    style: {
      stopColor: "#D7D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#D5D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6688,
    style: {
      stopColor: "#DDDDDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7464,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7738,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9135,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9363,
    style: {
      stopColor: "#EDEDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#E4E4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8C9CA"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M143.53,82.7l0.54,0.31c-0.13-0.07-0.2-0.23-0.2-0.44c0-0.44,0.31-0.97,0.68-1.19 c0.19-0.1,0.36-0.12,0.49-0.04l-0.55-0.32c-0.13-0.08-0.3-0.06-0.49,0.05c-0.38,0.22-0.69,0.75-0.68,1.19 C143.33,82.47,143.41,82.63,143.53,82.7z"
  })))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M125.67,126.56c-0.08,0-0.14,0-0.22-0.01l-0.14-0.01l-0.06-0.01c-0.31-0.03-0.61-0.09-0.91-0.2 c-0.27-0.09-0.55-0.21-0.81-0.37c-1.63-0.95-2.77-2.92-2.76-4.79l0.01-1.32c0.01-1.29,0.54-2.44,1.45-3.18l0.06-0.06l0.04-0.02 l0.06-0.06l0.14-0.09l0.16-0.12l0.19-0.08l2.44-1.42l0.03-0.01l27.45-15.96l27.45-15.96l0.03-0.01l1.93-1.12 c0.59-0.34,1.26-0.52,1.94-0.52c0.73,0,1.47,0.21,2.14,0.6c1.62,0.93,2.76,2.91,2.76,4.78v1.32c0,1.49-0.73,2.82-1.95,3.53 l-2.28,1.32l0,0c-0.03,0.02-0.05,0.03-0.09,0.05l-27.42,15.94l-27.42,15.94h0c0,0-0.02,0.01-0.02,0.01l-2.26,1.31v-0.01 c-0.11,0.06-0.23,0.13-0.34,0.17c-0.15,0.07-0.33,0.13-0.49,0.18h-0.02c-0.07,0.03-0.23,0.07-0.42,0.11 C126.13,126.53,125.9,126.56,125.67,126.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M186.12,82.09c0.74,0.43,1.38,1.11,1.81,1.87l0,0c0.24,0.39,0.43,0.92,0.57,1.35c0.15,0.5,0.21,1,0.19,1.48 l-0.09,1.25c0,0.51-0.21,1.07-0.38,1.51c0,0,0,0,0,0c0,0,0,0,0,0c0,0.01-0.01,0.02-0.01,0.03c-0.01,0.02-0.02,0.05-0.03,0.07 c-0.3,0.69-0.97,1.37-1.63,1.76l-2.25,1.31l0,0c-0.03,0.01-0.05,0.03-0.08,0.05l-26.12,15.19l-1.02,0.59l-27.16,15.79h0 c0,0-0.01,0.01-0.02,0.01l-2.24,1.3c0,0,0-0.01,0-0.01c0,0-0.01,0-0.01,0.01c-0.02,0.01-0.04,0.02-0.07,0.04c0,0,0,0-0.01,0 c-0.03,0.02-0.06,0.03-0.09,0.05c-0.05,0.02-0.1,0.05-0.15,0.07c-0.14,0.06-0.33,0.14-0.48,0.19l-0.01,0 c-0.06,0.03-0.24,0.08-0.41,0.11c-0.17,0.03-0.44,0.08-0.65,0.08c-0.07,0-0.15,0.01-0.21,0l-0.14,0l-0.05-0.01 c-0.22-0.02-0.48-0.03-0.69-0.09c0,0-0.01,0-0.01,0c0,0-0.01,0-0.01,0c-0.02-0.01-0.04-0.02-0.07-0.03c0,0,0,0,0,0 c-0.03-0.01-0.07-0.02-0.1-0.03c-0.01,0-0.02-0.01-0.03-0.01c-0.03-0.01-0.06-0.01-0.08-0.02c-0.02-0.01-0.04-0.01-0.06-0.02 c-0.05-0.02-0.11-0.04-0.16-0.06c-0.01,0-0.02-0.01-0.03-0.01c-0.07-0.03-0.14-0.06-0.2-0.09c0,0,0,0,0,0 c-0.08-0.04-0.16-0.08-0.24-0.13c-0.75-0.44-1.39-1.12-1.83-1.89l0,0c-0.24-0.39-0.43-0.93-0.57-1.36 c-0.14-0.49-0.21-0.99-0.19-1.46l0,0l0,0l0,0l0.1-1.26c0-0.52,0.21-1.08,0.39-1.53c0.01-0.01,0.01-0.03,0.02-0.04 c0.22-0.55,0.7-1.1,1.15-1.47l0.06-0.06l0.04-0.02l0.06-0.05l0.13-0.08l0.16-0.12l0.18-0.08l2.41-1.41l0.03-0.01l26.11-15.18 l1.06-0.62l27.18-15.81l0.02-0.01l1.91-1.11c0.09-0.05,0.21-0.11,0.3-0.16c0.01-0.01,0.03-0.01,0.04-0.02 c0.45-0.2,1.06-0.37,1.56-0.37c0.38,0,0.86,0.01,1.24,0.13C185.54,81.8,185.84,81.92,186.12,82.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M185.98,82.34c0.73,0.42,1.36,1.12,1.75,1.88l0,0c0.22,0.35,0.39,0.96,0.51,1.35 c0.13,0.48,0.18,0.96,0.14,1.41l-0.19,1.19c0,0.46-0.31,1.03-0.47,1.43c0,0,0,0,0,0c0,0,0,0,0,0c0,0.01,0,0.02-0.01,0.02 c-0.01,0.02-0.02,0.04-0.04,0.07c-0.27,0.62-1.06,1.35-1.65,1.69l-2.23,1.29l0,0c-0.02,0.01-0.05,0.03-0.08,0.04l-25.86,15.04 l-1.01,0.59l-26.89,15.64h0c0,0-0.01,0-0.01,0.01l-2.22,1.28c0,0,0-0.01,0-0.01c0,0-0.01,0-0.01,0.01 c-0.02,0.01-0.04,0.02-0.05,0.03c0,0,0,0-0.01,0c-0.03,0.02-0.06,0.03-0.09,0.05c-0.04,0.02-0.1,0.05-0.15,0.07 c-0.13,0.06-0.34,0.15-0.48,0.19l-0.01,0c-0.06,0.03-0.25,0.09-0.4,0.12c-0.16,0.03-0.45,0.11-0.64,0.11 c-0.06,0-0.15,0.02-0.21,0.01l-0.14,0.01l-0.05-0.01c-0.2-0.02-0.49,0.01-0.68-0.05c0,0-0.01,0-0.01-0.01c0,0-0.01,0-0.01,0 c-0.02-0.01-0.04-0.02-0.05-0.03c0,0,0,0,0,0c-0.03-0.01-0.07-0.01-0.1-0.02c-0.01,0-0.02,0-0.03-0.01 c-0.03,0-0.05-0.01-0.08-0.02c-0.02-0.01-0.04-0.01-0.06-0.02c-0.05-0.01-0.11-0.03-0.16-0.05c-0.01,0-0.02-0.01-0.03-0.01 c-0.07-0.02-0.13-0.05-0.2-0.09c0,0,0,0,0,0c-0.08-0.04-0.16-0.08-0.24-0.13c-0.74-0.43-1.37-1.14-1.76-1.9l0,0 c-0.22-0.35-0.39-0.97-0.51-1.36c-0.13-0.48-0.17-0.95-0.13-1.39l0,0l0,0l0,0l0.2-1.19c0-0.47,0.31-1.04,0.47-1.45 c0.01-0.01,0.01-0.03,0.02-0.04c0.2-0.49,0.78-1.07,1.18-1.4l0.05-0.05l0.03-0.02l0.06-0.05l0.13-0.08l0.15-0.11l0.17-0.08 l2.39-1.39l0.03-0.01l25.85-15.03l1.05-0.61l26.92-15.65l0.02-0.01l1.89-1.1c0.08-0.05,0.21-0.12,0.3-0.16 c0.01-0.01,0.03-0.01,0.04-0.02c0.41-0.18,1.07-0.41,1.53-0.41c0.34,0,0.88-0.05,1.21,0.06 C185.39,82.06,185.69,82.17,185.98,82.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M185.83,82.6c0.72,0.42,1.33,1.14,1.68,1.89l0,0c0.19,0.31,0.34,1,0.45,1.35c0.12,0.47,0.15,0.92,0.09,1.33 l-0.28,1.12c0,0.41-0.41,1-0.55,1.35c0,0,0,0,0,0c0,0,0,0,0,0c0,0.01,0,0.01,0,0.02c-0.01,0.02-0.03,0.04-0.04,0.06 c-0.24,0.55-1.15,1.32-1.68,1.62l-2.2,1.28l0,0c-0.02,0.01-0.05,0.03-0.07,0.04l-25.6,14.89l-1,0.58l-26.63,15.49h0 c0,0-0.01,0-0.01,0.01l-2.19,1.27c0,0,0-0.01,0-0.01c0,0-0.01,0.01-0.01,0.01c-0.01,0.01-0.03,0.01-0.04,0.02c0,0,0,0-0.01,0 c-0.03,0.02-0.06,0.04-0.09,0.05c-0.04,0.02-0.1,0.05-0.14,0.07c-0.11,0.05-0.35,0.16-0.47,0.2l-0.01,0 c-0.05,0.02-0.26,0.1-0.4,0.13c-0.14,0.03-0.46,0.13-0.63,0.13c-0.06,0-0.15,0.02-0.21,0.02l-0.13,0.01l-0.04-0.01 c-0.17-0.02-0.5,0.04-0.67,0c0,0,0,0-0.01-0.01c0,0-0.01,0-0.01,0c-0.01-0.01-0.03-0.02-0.04-0.03c0,0,0,0,0,0 c-0.03-0.01-0.06-0.01-0.1-0.01c-0.01,0-0.02,0-0.03,0c-0.03,0-0.05-0.01-0.08-0.01c-0.02,0-0.04-0.01-0.06-0.01 c-0.05-0.01-0.11-0.03-0.16-0.05c-0.01,0-0.02-0.01-0.03-0.01c-0.07-0.02-0.13-0.05-0.2-0.08c0,0,0,0,0,0 c-0.08-0.04-0.16-0.08-0.24-0.13c-0.72-0.43-1.34-1.15-1.69-1.91l0,0c-0.19-0.31-0.35-1.01-0.45-1.35 c-0.11-0.46-0.14-0.91-0.08-1.32l0,0l0,0l0,0l0.29-1.13c0-0.42,0.41-1.01,0.56-1.37c0.01-0.01,0.02-0.02,0.02-0.04 c0.18-0.44,0.85-1.05,1.21-1.34l0.05-0.05l0.03-0.02l0.05-0.04l0.13-0.08l0.15-0.11l0.17-0.08l2.36-1.38l0.02-0.01l25.58-14.88 l1.04-0.6l26.65-15.49l0.02-0.01l1.88-1.09c0.07-0.04,0.22-0.12,0.29-0.16c0.01-0.01,0.03-0.01,0.04-0.02 c0.36-0.16,1.09-0.44,1.49-0.44c0.31,0,0.89-0.11,1.19-0.01C185.24,82.33,185.53,82.43,185.83,82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M185.68,82.85c0.71,0.41,1.31,1.15,1.61,1.9l0,0c0.17,0.27,0.3,1.04,0.4,1.34c0.1,0.46,0.11,0.88,0.04,1.26 l-0.38,1.06c0,0.36-0.51,0.96-0.63,1.27c0,0,0,0,0,0c0,0,0,0,0,0c0,0.01,0,0.01,0,0.01c-0.01,0.02-0.03,0.04-0.04,0.06 c-0.21,0.49-1.24,1.29-1.7,1.56l-2.18,1.27l0,0c-0.02,0.01-0.05,0.03-0.07,0.04l-25.34,14.74l-0.99,0.57l-26.37,15.33h0 c0,0-0.01,0-0.01,0.01l-2.17,1.26c0,0,0-0.01,0-0.01c0,0-0.01,0.01-0.01,0.01c-0.01,0-0.02,0.01-0.03,0.01c0,0,0,0-0.01,0 c-0.03,0.02-0.06,0.04-0.08,0.05c-0.03,0.02-0.1,0.05-0.14,0.07c-0.1,0.04-0.35,0.17-0.46,0.2l-0.01,0 c-0.05,0.02-0.27,0.12-0.39,0.14c-0.12,0.02-0.47,0.15-0.62,0.15c-0.05,0-0.15,0.03-0.2,0.03l-0.13,0.02l-0.04-0.01 c-0.15-0.01-0.51,0.08-0.66,0.04c0,0,0,0-0.01-0.01c0,0-0.01,0-0.01,0c-0.01-0.01-0.02-0.02-0.03-0.03c0,0,0,0,0,0 c-0.03,0-0.06,0-0.1,0c-0.01,0-0.02,0-0.03,0c-0.03,0-0.05,0-0.08-0.01c-0.02,0-0.04-0.01-0.06-0.01 c-0.05-0.01-0.11-0.02-0.16-0.04c-0.01,0-0.02,0-0.03-0.01c-0.07-0.02-0.13-0.04-0.2-0.08c0,0,0,0,0,0 c-0.08-0.03-0.16-0.07-0.24-0.12c-0.71-0.42-1.32-1.16-1.62-1.92l0,0c-0.17-0.27-0.3-1.04-0.4-1.35 c-0.1-0.45-0.11-0.87-0.03-1.24l0,0l0,0l0,0l0.38-1.06c0-0.36,0.52-0.97,0.64-1.28c0.01-0.01,0.02-0.02,0.03-0.03 c0.16-0.38,0.93-1.02,1.24-1.28l0.05-0.04l0.02-0.01l0.05-0.04l0.12-0.07l0.15-0.1l0.16-0.08l2.34-1.36l0.02-0.01l25.32-14.72 l1.02-0.59l26.38-15.34l0.02-0.01l1.86-1.08c0.06-0.04,0.22-0.12,0.29-0.16c0.01-0.01,0.02-0.01,0.04-0.02 c0.32-0.14,1.11-0.48,1.46-0.48c0.27,0,0.9-0.17,1.17-0.08C185.09,82.59,185.38,82.68,185.68,82.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M185.53,83.11c0.7,0.41,1.29,1.17,1.55,1.91l0,0c0.14,0.23,0.26,1.08,0.34,1.34 c0.09,0.44,0.08,0.84-0.02,1.18l-0.47,1c0,0.31-0.61,0.93-0.72,1.19c0,0,0,0,0,0c0,0,0,0,0,0c0,0.01,0,0,0,0.01 c-0.01,0.02-0.03,0.04-0.04,0.05c-0.18,0.42-1.33,1.26-1.73,1.49l-2.16,1.25l0,0c-0.02,0.01-0.04,0.03-0.06,0.04l-25.08,14.58 l-0.97,0.57l-26.11,15.18h0c0,0-0.01,0-0.01,0.01l-2.15,1.25c0,0,0-0.01,0-0.01c0,0-0.01,0.01-0.01,0.01c0,0-0.01,0-0.02,0 c0,0,0,0-0.01,0c-0.03,0.02-0.05,0.04-0.08,0.05c-0.03,0.01-0.11,0.06-0.13,0.07c-0.08,0.04-0.36,0.18-0.45,0.21l-0.01,0 c-0.04,0.02-0.28,0.13-0.38,0.15c-0.1,0.02-0.48,0.18-0.61,0.18c-0.04,0-0.15,0.04-0.2,0.04l-0.13,0.02l-0.03,0 c-0.13-0.01-0.52,0.12-0.64,0.08c0,0,0-0.01,0-0.01c0,0-0.01,0-0.01,0c-0.01-0.01-0.01-0.02-0.02-0.04c0,0,0,0,0,0 c-0.03,0-0.06,0-0.09,0.01c-0.01,0-0.02,0-0.03,0c-0.03,0-0.05,0-0.08,0c-0.02,0-0.04,0-0.06-0.01 c-0.05-0.01-0.11-0.02-0.16-0.03c-0.01,0-0.02,0-0.03-0.01c-0.07-0.02-0.13-0.04-0.2-0.07c0,0,0,0,0,0 c-0.08-0.03-0.15-0.07-0.24-0.12c-0.7-0.41-1.29-1.17-1.55-1.93l0,0c-0.14-0.23-0.26-1.08-0.34-1.34 c-0.09-0.44-0.07-0.84,0.02-1.17l0,0l0,0l0,0l0.48-0.99c0-0.31,0.62-0.93,0.73-1.2c0.01-0.01,0.02-0.02,0.03-0.03 c0.13-0.33,1-1,1.27-1.22l0.04-0.04l0.02-0.01l0.05-0.04l0.12-0.07l0.14-0.1l0.16-0.08l2.31-1.35l0.02-0.01l25.05-14.57 l1.01-0.59l26.11-15.18l0.01-0.01l1.85-1.07c0.05-0.03,0.23-0.13,0.28-0.15c0.01-0.01,0.02-0.01,0.04-0.02 c0.27-0.12,1.12-0.51,1.43-0.51c0.23,0,0.92-0.23,1.14-0.16C184.94,82.85,185.23,82.93,185.53,83.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M185.38,83.36c0.69,0.4,1.26,1.18,1.48,1.92l0,0c0.12,0.19,0.21,1.12,0.28,1.33 c0.07,0.43,0.04,0.81-0.07,1.11l-0.57,0.93c0,0.26-0.71,0.89-0.8,1.11c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.01,0.01 c-0.02,0.02-0.03,0.03-0.05,0.05c-0.15,0.35-1.43,1.23-1.75,1.42l-2.13,1.24l0,0c-0.01,0.01-0.04,0.03-0.06,0.03l-24.82,14.43 l-0.96,0.56l-25.84,15.03l0,0c0,0-0.01,0-0.01,0.01l-2.13,1.23c0,0,0-0.01,0-0.01c0,0-0.01,0.01-0.01,0.01c0,0,0-0.01,0-0.01 c0,0,0,0-0.01,0c-0.03,0.02-0.05,0.04-0.08,0.05c-0.02,0.01-0.11,0.06-0.13,0.07c-0.07,0.03-0.37,0.19-0.44,0.21l-0.01,0 c-0.03,0.01-0.29,0.14-0.37,0.16c-0.09,0.02-0.49,0.2-0.6,0.2c-0.03,0-0.16,0.05-0.19,0.05l-0.12,0.03l-0.03,0 c-0.11-0.01-0.53,0.15-0.63,0.12c0,0,0-0.01,0-0.01c0,0-0.01,0-0.01,0c0-0.01,0-0.03,0-0.04c0,0,0,0,0,0 c-0.03,0.01-0.06,0.01-0.09,0.01c-0.01,0-0.02,0-0.03,0c-0.03,0-0.05,0.01-0.08,0.01c-0.02,0-0.04,0-0.06,0 c-0.05,0-0.11-0.02-0.16-0.03c0,0-0.02,0-0.03-0.01c-0.07-0.02-0.13-0.04-0.2-0.07c0,0,0,0,0,0c-0.08-0.03-0.15-0.07-0.23-0.12 c-0.69-0.41-1.27-1.19-1.49-1.94l0,0c-0.12-0.2-0.22-1.12-0.28-1.34c-0.07-0.42-0.04-0.8,0.07-1.1l0,0l0,0l0,0l0.57-0.93 c0-0.26,0.72-0.9,0.81-1.12c0.01-0.01,0.02-0.02,0.03-0.03c0.11-0.27,1.08-0.97,1.3-1.16l0.04-0.04l0.02-0.01l0.04-0.03 l0.11-0.07l0.14-0.09l0.15-0.08l2.28-1.33l0.02-0.01l24.79-14.41l1-0.58l25.84-15.03l0.01-0.01l1.83-1.06 c0.05-0.03,0.23-0.13,0.28-0.15c0.01-0.01,0.02-0.01,0.04-0.02c0.23-0.1,1.14-0.54,1.39-0.54c0.19,0,0.93-0.29,1.12-0.23 C184.79,83.12,185.08,83.19,185.38,83.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M185.23,83.62c0.68,0.39,1.24,1.2,1.41,1.93l0,0c0.1,0.15,0.17,1.16,0.22,1.33 c0.06,0.42,0.01,0.77-0.12,1.03l-0.66,0.87c0,0.2-0.82,0.85-0.89,1.03c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.01,0,0.01,0 c-0.02,0.02-0.03,0.03-0.05,0.05c-0.12,0.28-1.52,1.2-1.78,1.36l-2.11,1.23l0,0c-0.01,0.01-0.04,0.03-0.05,0.03l-24.56,14.28 l-0.95,0.55l-25.58,14.88l0,0c0,0-0.01,0-0.01,0.01l-2.1,1.22c0,0,0-0.01,0-0.01c0,0-0.01,0.01-0.01,0.01 c0.01-0.01,0-0.01,0.01-0.02c0,0,0,0-0.01,0c-0.03,0.02-0.05,0.04-0.08,0.05c-0.02,0.01-0.11,0.06-0.12,0.07 c-0.06,0.03-0.37,0.2-0.43,0.22l-0.01,0c-0.03,0.01-0.3,0.15-0.37,0.16c-0.07,0.01-0.5,0.23-0.59,0.23 c-0.03,0-0.16,0.06-0.19,0.06l-0.12,0.04l-0.03,0c-0.09-0.01-0.54,0.19-0.62,0.17c0,0,0-0.01,0-0.01c0,0-0.01,0-0.01,0 c0-0.01,0.01-0.03,0.01-0.04c0,0,0,0,0,0c-0.03,0.01-0.06,0.02-0.09,0.02c-0.01,0-0.02,0-0.03,0c-0.03,0.01-0.05,0.01-0.08,0.01 c-0.02,0-0.04,0-0.06,0c-0.05,0-0.11-0.01-0.16-0.02c0,0-0.02,0-0.03,0c-0.07-0.01-0.13-0.03-0.2-0.06c0,0,0,0,0,0 c-0.08-0.03-0.15-0.07-0.23-0.11c-0.68-0.4-1.24-1.2-1.42-1.94l0,0c-0.1-0.16-0.17-1.16-0.23-1.33 c-0.06-0.41-0.01-0.76,0.13-1.02l0,0l0,0l0,0l0.66-0.86c0-0.21,0.82-0.86,0.89-1.04c0.01-0.01,0.02-0.02,0.03-0.03 c0.09-0.22,1.15-0.95,1.33-1.09l0.04-0.03l0.01-0.01l0.04-0.03l0.11-0.06l0.14-0.09l0.15-0.07l2.26-1.32l0.01-0.01l24.52-14.26 l0.99-0.57l25.57-14.87l0.01-0.01l1.81-1.05c0.04-0.02,0.24-0.14,0.28-0.15c0.01-0.01,0.02-0.01,0.04-0.02 c0.18-0.08,1.16-0.58,1.36-0.58c0.15,0,0.95-0.35,1.1-0.3C184.64,83.38,184.93,83.44,185.23,83.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M185.08,83.87c0.66,0.38,1.22,1.21,1.34,1.94l0,0c0.07,0.12,0.12,1.2,0.17,1.32 c0.04,0.4-0.02,0.73-0.18,0.96l-0.76,0.8c0,0.15-0.92,0.82-0.97,0.95c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.01-0.01,0.01,0 c-0.02,0.02-0.03,0.03-0.05,0.04c-0.09,0.21-1.61,1.18-1.8,1.29l-2.09,1.21l0,0c-0.01,0-0.04,0.02-0.05,0.03l-24.3,14.13 l-0.94,0.55l-25.32,14.72l0,0c0,0,0,0-0.01,0l-2.08,1.21c0.01,0,0.01,0,0.01-0.01c0,0-0.01,0.01-0.01,0.01 c0.01-0.01,0.01-0.02,0.02-0.03c0,0,0,0-0.01,0c-0.02,0.02-0.05,0.04-0.08,0.05c-0.01,0.01-0.11,0.06-0.12,0.07 c-0.04,0.02-0.38,0.21-0.43,0.22l0,0c-0.02,0.01-0.31,0.16-0.36,0.17c-0.05,0.01-0.52,0.25-0.58,0.25 c-0.02,0-0.16,0.07-0.18,0.07l-0.12,0.04l-0.02,0c-0.07-0.01-0.55,0.23-0.61,0.21c0,0,0-0.01,0-0.01c0,0-0.01,0-0.01,0 c0.01-0.01,0.01-0.03,0.02-0.04c0,0,0,0,0,0c-0.03,0.01-0.06,0.02-0.09,0.03c-0.01,0-0.02,0-0.03,0.01 c-0.03,0.01-0.05,0.01-0.08,0.02c-0.02,0-0.04,0-0.06,0c-0.05,0-0.11-0.01-0.16-0.02c0,0-0.02,0-0.03,0 c-0.06-0.01-0.13-0.03-0.2-0.06c0,0,0,0,0,0c-0.08-0.03-0.15-0.06-0.23-0.11c-0.66-0.39-1.22-1.21-1.35-1.95l0,0 c-0.07-0.12-0.13-1.2-0.17-1.33c-0.04-0.4,0.03-0.72,0.18-0.95l0,0l0,0l0,0l0.76-0.8c0-0.16,0.92-0.82,0.98-0.96 c0.01-0.01,0.02-0.01,0.03-0.02c0.07-0.16,1.23-0.92,1.36-1.03l0.03-0.03l0.01-0.01l0.04-0.03l0.1-0.06l0.13-0.08l0.14-0.07 l2.23-1.3l0.01,0l24.25-14.1l0.97-0.57l25.31-14.71l0.01,0l1.8-1.05c0.03-0.02,0.25-0.14,0.27-0.15 c0.01-0.01,0.02-0.01,0.04-0.02c0.14-0.06,1.18-0.61,1.33-0.61c0.11,0,0.96-0.41,1.08-0.37 C184.48,83.65,184.78,83.69,185.08,83.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M184.93,84.13c0.65,0.38,1.19,1.22,1.28,1.95l0,0c0.05,0.08,0.08,1.23,0.11,1.32 c0.03,0.39-0.06,0.69-0.23,0.88l-0.85,0.74c0,0.1-1.02,0.78-1.05,0.87c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.01-0.01,0.02-0.01 c-0.02,0.01-0.04,0.03-0.06,0.04c-0.06,0.14-1.7,1.15-1.83,1.22l-2.06,1.2l0,0c-0.01,0-0.04,0.02-0.04,0.03l-24.04,13.98 l-0.93,0.54l-25.06,14.57l0,0c0,0,0,0,0,0l-2.06,1.19c0.01,0,0.01,0,0.01-0.01c0,0-0.01,0.01-0.01,0.01 c0.01-0.01,0.02-0.02,0.03-0.03c0,0,0,0-0.01,0c-0.02,0.02-0.05,0.04-0.08,0.05c-0.01,0-0.11,0.06-0.12,0.06 c-0.03,0.01-0.39,0.22-0.42,0.23l0,0c-0.01,0.01-0.32,0.17-0.35,0.18c-0.03,0.01-0.53,0.27-0.57,0.27 c-0.01,0-0.16,0.08-0.18,0.08l-0.11,0.05l-0.02,0c-0.04,0-0.56,0.26-0.6,0.25c0,0,0.01-0.01,0-0.01c0,0-0.01,0.01-0.01,0.01 c0.01-0.01,0.02-0.03,0.03-0.05c0,0,0,0,0,0c-0.03,0.01-0.06,0.03-0.09,0.04c-0.01,0-0.02,0.01-0.03,0.01 c-0.03,0.01-0.05,0.01-0.08,0.02c-0.02,0-0.04,0-0.06,0.01c-0.05,0.01-0.11,0-0.16-0.01c0,0-0.02,0-0.03,0 c-0.06-0.01-0.13-0.02-0.2-0.05c0,0,0,0,0,0c-0.08-0.03-0.15-0.06-0.23-0.11c-0.65-0.39-1.19-1.23-1.28-1.96l0,0 c-0.05-0.08-0.08-1.23-0.11-1.32c-0.03-0.38,0.06-0.68,0.23-0.88l0,0l0,0l0,0l0.85-0.73c0-0.1,1.03-0.79,1.06-0.88 c0.01-0.01,0.02-0.01,0.03-0.02c0.04-0.11,1.3-0.89,1.39-0.97l0.03-0.02l0.01,0l0.03-0.02l0.1-0.06l0.13-0.08l0.13-0.07 l2.21-1.29l0.01,0l23.99-13.95l0.96-0.56l25.04-14.56l0.01,0l1.78-1.04c0.02-0.01,0.25-0.14,0.27-0.15 c0.01-0.01,0.02-0.01,0.04-0.02c0.09-0.04,1.19-0.65,1.29-0.65c0.08,0,0.98-0.47,1.05-0.44 C184.33,83.91,184.62,83.95,184.93,84.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M184.79,84.38c0.64,0.37,1.17,1.24,1.21,1.96l0,0c0.02,0.04,0.04,1.27,0.05,1.32 c0.01,0.37-0.09,0.65-0.28,0.81l-0.95,0.67c0,0.05-1.12,0.75-1.14,0.79c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.01-0.01,0.02-0.01 c-0.02,0.01-0.04,0.02-0.06,0.04c-0.03,0.07-1.79,1.12-1.85,1.16l-2.04,1.19l0,0c0,0-0.04,0.02-0.04,0.02l-23.78,13.83 l-0.91,0.53l-24.8,14.42l0,0c0,0,0,0,0,0l-2.03,1.18c0.01,0,0.01,0,0.01-0.01c0,0-0.01,0.01-0.01,0.01 c0.02-0.01,0.03-0.03,0.05-0.04c0,0,0,0-0.01,0c-0.02,0.02-0.05,0.04-0.07,0.05c0,0-0.11,0.06-0.11,0.06 c-0.01,0.01-0.4,0.23-0.41,0.23l0,0c-0.01,0-0.33,0.19-0.34,0.19c-0.02,0-0.54,0.3-0.56,0.3c-0.01,0-0.17,0.09-0.17,0.09 l-0.11,0.06l-0.01,0c-0.02,0-0.57,0.3-0.59,0.29c0.01,0,0.01-0.01,0.01-0.01c0,0-0.01,0.01-0.01,0.01 c0.02-0.01,0.03-0.03,0.05-0.05c0,0,0,0,0,0c-0.03,0.02-0.06,0.03-0.09,0.04c-0.01,0-0.02,0.01-0.03,0.01 c-0.03,0.01-0.05,0.02-0.08,0.03c-0.02,0-0.04,0-0.06,0.01c-0.05,0-0.1,0-0.16,0c0,0-0.02,0-0.03,0 c-0.06-0.01-0.13-0.02-0.2-0.05c0,0,0,0,0,0c-0.08-0.02-0.15-0.06-0.23-0.1c-0.64-0.38-1.17-1.24-1.21-1.97l0,0 c-0.02-0.04-0.04-1.27-0.05-1.32c-0.01-0.37,0.1-0.65,0.28-0.8l0,0l0,0l0,0l0.94-0.67c0-0.05,1.13-0.75,1.14-0.8 c0.01,0,0.03-0.01,0.04-0.02c0.02-0.05,1.38-0.87,1.42-0.91l0.03-0.02l0,0l0.03-0.02l0.09-0.06l0.12-0.08l0.13-0.07l2.18-1.27 l0,0l23.72-13.79l0.95-0.55l24.77-14.4l0,0l1.77-1.03c0.01-0.01,0.26-0.15,0.27-0.15c0.01-0.01,0.02-0.01,0.04-0.02 c0.05-0.02,1.21-0.68,1.26-0.68c0.04,0,0.99-0.53,1.03-0.51C184.18,84.17,184.47,84.2,184.79,84.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.64,84.64c-0.32-0.18-0.61-0.2-0.81-0.08l-2.23,1.3c-0.02,0.01-0.03,0.01-0.04,0.02l-27.45,15.96l-27.45,15.96 c-0.01,0.01-0.03,0.01-0.04,0.02l-2.27,1.32l0,0l0,0l0,0c-0.21,0.12-0.34,0.37-0.34,0.73l0,1.31l0,0c0,0.73,0.51,1.61,1.14,1.98 c0.08,0.05,0.15,0.08,0.23,0.1h0c0.07,0.03,0.14,0.04,0.2,0.04c0.01,0,0.02,0,0.03,0c0.06,0,0.11,0,0.17,0 c0.02-0.01,0.03-0.01,0.06-0.01c0.02-0.01,0.05-0.02,0.08-0.03c0.04-0.02,0.08-0.04,0.11-0.07c0,0,0,0,0,0 c-0.02,0.02-0.04,0.04-0.06,0.05l0.01-0.01c0,0,0,0.01-0.01,0.01l2.26-1.32c0.03-0.01,0.05-0.04,0.07-0.06c0,0,0,0,0.01,0 c-0.02,0.02-0.04,0.04-0.06,0.05l0.01-0.01c0,0.01,0,0.01-0.01,0.01l27.45-15.96l27.45-15.96c0.02-0.01,0.04-0.02,0.06-0.03 c-0.01,0-0.02,0.02-0.02,0.02h0c0,0,0,0,0,0l2.26-1.32c0.21-0.12,0.34-0.37,0.34-0.73l0.01-1.31l0,0 C185.78,85.89,185.27,85.01,184.64,84.64z"
  }))), /*#__PURE__*/React.createElement("g", null, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "125.3,117.65 125.3,119.41 123.51,118.39 123.51,116.63  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "125.8,117.36 125.3,117.65 123.51,116.63 124.02,116.33  "
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "182.27,84.76 182.27,86.51 180.48,85.49 180.48,83.74  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "182.77,84.46 182.27,84.76 180.48,83.74 180.99,83.44  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M187.29,81.48c-0.35-0.2-0.67-0.22-0.9-0.09l-2.5,1.45l0,0v0.01c0,0,0,0,0,0 c-0.24,0.13-0.37,0.41-0.37,0.81l-0.01,1.45c0,0.8,0.56,1.78,1.26,2.19c0.4,0.23,0.76,0.21,0.99,0 c-0.02,0.03-0.05,0.06-0.09,0.08l2.5-1.46c0.23-0.13,0.37-0.42,0.37-0.81l0.01-1.45C188.54,82.87,187.97,81.88,187.29,81.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.9667,
    y1: 86.0164,
    x2: 187.2313,
    y2: 86.4746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#383A45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C0E1C"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M188.17,85.92l-2.5,1.46c0.22-0.13,0.37-0.42,0.37-0.81l2.51-1.46 C188.54,85.51,188.4,85.79,188.17,85.92z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "186.04,85.12 188.54,83.66 188.54,85.11 186.03,86.57  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.5036,
    y1: 85.1171,
    x2: 186.0387,
    y2: 85.1171
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#383A45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E505A"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M184.77,82.94c0.7,0.4,1.26,1.38,1.26,2.18l-0.01,1.45c0,0.79-0.57,1.12-1.27,0.72 c-0.7-0.4-1.26-1.38-1.26-2.18l0.01-1.45C183.51,82.87,184.08,82.54,184.77,82.94z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.5786,
    y1: 81.8621,
    x2: 187.1042,
    y2: 84.5046
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#383A45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#919198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#919198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3279,
    style: {
      stopColor: "#7A7B83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4483,
    style: {
      stopColor: "#5D5E68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    style: {
      stopColor: "#494A54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6862,
    style: {
      stopColor: "#3C3E49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#383A45"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M184.77,82.94c0.7,0.4,1.26,1.38,1.26,2.18l2.5-1.46c0-0.79-0.57-1.78-1.26-2.18 c-0.35-0.2-0.67-0.22-0.9-0.08l-2.5,1.46C184.11,82.72,184.43,82.73,184.77,82.94z"
  })))), /*#__PURE__*/React.createElement("g", null, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M184.76,82.93c-0.35-0.2-0.67-0.22-0.89-0.08l-60.71,35.3c0,0,0,0,0,0c-0.22,0.13-0.37,0.42-0.37,0.81 v1.45c0,0.8,0.56,1.78,1.26,2.19c0.4,0.23,0.76,0.21,1,0c-0.04,0.03-0.06,0.06-0.1,0.08l60.7-35.3 c0.23-0.13,0.37-0.41,0.37-0.82l0.01-1.45C186.03,84.32,185.46,83.34,184.76,82.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.3003,
    y1: 104.2984,
    x2: 155.6702,
    y2: 104.939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B6B7B8"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M185.65,87.37l-60.7,35.3c0.22-0.13,0.37-0.41,0.37-0.81l60.7-35.3 C186.02,86.96,185.88,87.24,185.65,87.37z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "125.32,120.42 186.03,85.11 186.02,86.56 125.32,121.86  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.9153,
    y1: 100.1484,
    x2: 155.5443,
    y2: 102.9699
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4311,
    style: {
      stopColor: "#E3E3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6186,
    style: {
      stopColor: "#D6D6D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#D2D2D3"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M184.76,82.93c-0.35-0.2-0.67-0.22-0.89-0.08l-60.71,35.3c0.23-0.13,0.55-0.12,0.9,0.09 c0.69,0.4,1.26,1.39,1.26,2.18l60.7-35.31C186.03,84.32,185.46,83.34,184.76,82.93z"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.06,118.24c0.69,0.4,1.26,1.39,1.26,2.18v1.44c-0.01,0.8-0.58,1.13-1.27,0.73 c-0.7-0.4-1.26-1.38-1.26-2.19v-1.45C122.8,118.16,123.37,117.83,124.06,118.24z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M124.05,118.24c-0.35-0.2-0.67-0.22-0.9-0.09l-2.5,1.46l0,0l-0.01,0.01c0,0,0.01,0,0.01-0.01 c-0.23,0.13-0.37,0.42-0.37,0.82l-0.01,1.44c0,0.8,0.57,1.79,1.26,2.19c0.41,0.23,0.77,0.22,1,0c-0.03,0.03-0.06,0.06-0.1,0.08 l2.5-1.46c0.24-0.13,0.37-0.42,0.37-0.81l0.01-1.45C125.32,119.62,124.75,118.64,124.05,118.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.7349,
    y1: 122.7663,
    x2: 124.0025,
    y2: 123.2299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#383A45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C0E1C"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M124.94,122.67l-2.5,1.46c0.23-0.14,0.37-0.42,0.37-0.81l2.51-1.47 C125.3,122.26,125.17,122.54,124.94,122.67z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "122.81,121.87 125.31,120.42 125.3,121.86 122.8,123.33  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.2748,
    y1: 121.8705,
    x2: 122.8097,
    y2: 121.8705
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#383A45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E505A"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M121.54,119.69c0.7,0.41,1.27,1.38,1.27,2.18l-0.01,1.45c0,0.8-0.57,1.13-1.27,0.72 c-0.69-0.4-1.26-1.39-1.26-2.19l0.01-1.44C120.28,119.62,120.85,119.29,121.54,119.69z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.3479,
    y1: 118.6123,
    x2: 123.8756,
    y2: 121.2584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#383A45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#919198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#919198"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3279,
    style: {
      stopColor: "#7A7B83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4483,
    style: {
      stopColor: "#5D5E68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    style: {
      stopColor: "#494A54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6862,
    style: {
      stopColor: "#3C3E49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#383A45"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M124.05,118.24c-0.35-0.21-0.67-0.22-0.9-0.09l-2.5,1.46c0.23-0.13,0.54-0.11,0.89,0.09 c0.7,0.41,1.27,1.38,1.27,2.18l2.5-1.46C125.32,119.62,124.75,118.64,124.05,118.24z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourEncastrable);
export default __webpack_public_path__ + "static/media/Four-encastrable.94d993c9613b17e22ae035b38c732065.svg";
export { ForwardRef as ReactComponent };